import { useState, useEffect, useRef, useCallback } from "react";
import "../css/PagesCommonStyle.css";
import {
    faMagnifyingGlass,
    faPrint,
    faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileExcel,
    faFilePdf,
    faFile,
} from "@fortawesome/free-regular-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
    faCircleInfo,
    faArrowsRotate,
    faAnglesDown,
    faAnglesUp,
    faXmark,
    faArrowRight,
    faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import {
    APIConstants,
    IntelliBillConstants,
    ClaimApprovalConstants,
    ClaimStatusConstants,
    CommonAPIConstants,
    PostingpaymentsConstants,
    FilesAPIConstants,
} from "../utilities/Constants";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Draggable from "react-draggable";
import { useParams, useLocation } from "react-router-dom";
import DebouncedInput from "../common/hook/DebouncedInput";
import { exportExcel } from "../utilities/exportToExcel";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PrintColumnModal from "../components/PrintColumnModal";
const ClaimStatus = () => {
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date("2015-01-01");

    const today = new Date();
    const formatCurDate = format(today, "MM/dd/yyyy");

    const rowsPerPage = 200;

    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(defaultDate, defaultFromDate); // State to store start date
    const [endDate, setEndDate] = useState(defaultDate); // State to store end date
    const [loading, setLoading] = useState(false);

    //   const ServiceLocValues = [
    //     { TextField: "Office - 11", ValueField: "11" },
    //     { TextField: "Home - 12", ValueField: "12" },
    //     { TextField: "SUD - 57", ValueField: "57" },
    //     { TextField: "Lab - 81", ValueField: "81" },
    //   ];

    //   const [ServiceLocations, setServiceLocations] = useState([]);
    //   const [selectedCMS33a, setSelectedCMS33a] = useState("0");
    //   const [selectedCMS33b, setSelectedCMS33b] = useState("0");
    //   const [selectedBillingNPI, setSelectedBillingNPI] = useState("0");
    //   const [selectedPracticeProvider, setSelectedPracticeProvider] = useState("0");
    //   const [selectedProvidersCategory, setSelectedProvidersCategory] =
    useState("0");
    const [selectedSearchFilter, setSelectedSearchFilter] = useState("9");
    const [selectedLocation, setSelectedLocation] = useState("-1");
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] =
        useState("");
    //   const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] =
    useState("0");
    //   const [selectedServiceLocation, setSelectedServicelocation] = useState("0");
    const [selectedFilterProvider, setSelectedFilterProvider] = useState("0");

    const [locations, setLocations] = useState([]);
    //   const [cms33aData, setCMS33aData] = useState([]);
    //   const [cms33bData, setCMS33bData] = useState([]);
    //   const [providerCategory, setProviderCategory] = useState([]);
    //   const [searchFilterData, setSearchFilterData] = useState([]);
    //   const [practiceProvider, setPracticeProvider] = useState([]);
    //   const [statusRadioButton, setStatusRadioButton] = useState([]);
    //   const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    //   const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState("");

    const [suggestions, setSuggestions] = useState([]);
    const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
    //   const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
    const [sPatID, setSPatID] = useState("");
    const [sInsID, setSInsID] = useState("");
    const [sClaimStatus, setsClaimStatus] = useState("");
    //   const [rowsValidation, setRowsValidation] = useState("");
    //   const [isChecked, setIsChecked] = useState(false);

    const [tableDetails, setTableDetails] = useState([]);
    //   const [tableInsDetails, setTableInsDetails] = useState([]);
    const [checkEligibility, setCheckEligibility] = useState([]);
    //   const [selectedClaims, setSelectedClaims] = useState([]);
    //   const [selectAllDropdown, setSelectAllDropdown] = useState([]);
    //   const [checkboxes, setCheckboxes] = useState();

    const [selectedRows, setSelectedRows] = useState([]);

    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [SecInsuranceAllCheckbox, setSecInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] =
        useState(tableDetails);

    const [searchByPatient, setSearchByPatient] = useState("");
    const [searchByDOB, setSearchByDOB] = useState("");
    const [searchByInsurance, setSearchByInsurance] = useState("");
    const [searchByProvider, setSearchByProvider] = useState("");
    const [searchByCPT, setSearchByCPT] = useState("");
    const [searchByDOS, setSearchByDOS] = useState("");
    //   const [searchByPostingDate, setSearchByPostingDate] = useState("");
    const [searchBySubmitdate, setSearchBySubmitdate] = useState("");
    const [searchBySecSubmitdate, setSearchBySecSubmitdate] = useState("");
    //   const [searchByICD, setSearchByICD] = useState("");
    const [searchByTotalCharge, setSearchByTotalCharge] = useState("");
    const [searchByStatus, setSearchByStatus] = useState("");
    //   const [searchByRecievedCharge, setSearchByRecievedCharge] = useState("");
    //   const [searchBySubmitter, setSearchBySubmitter] = useState("");
    const [searchByClaim, setSearchByClaim] = useState("");
    const [searchByRcvdCharge, setSearchByRcvdCharge] = useState("");
    const [searchByWriteOffValue, setSearchByWriteOffValue] = useState("");
    const [searchByAdminWriteOffValue, setSearchByAdminWriteOffValue] =
        useState("");
    const [searchByBalance, setSearchByBalance] = useState("");
    const [searchByCheckNum, setSearchByCheckNum] = useState("");
    const [searchByCheckDate, setSearchByCheckDate] = useState("");
    const [searchByPayerRef, setSearchByPayerRef] = useState("");
    const [searchByDeductible, setSearchByDeductible] = useState("");
    const [searchByPatientRes, setSearchByPatientRes] = useState("");
    const [searchByClearingHouse, setSearchByClearingHouse] = useState("");
    const [searchByUpdatedBy, setSearchByUpdatedBy] = useState("");
    const [searchBySubmittedBy, setSearchBySubmittedBy] = useState("");
    const [searchByCopay, setSearchByCopay] = useState("");
    const [searchFederal, setSearchFederal] = useState("");
    const [searchBySecRcvdCharge, setSearchBySecRcvdCharge] = useState("");
    const [searchBySecInsurance, setSearchBySecInsurance] = useState("");
    const [searchBySecCheckNum, setSearchBySecCheckNum] = useState("");
    const [searchBySecCheckDate, setSearchBySecCheckDate] = useState("");
    const [searchBySecPayerRef, setSearchBySecPayerRef] = useState("");
    const [searchByAdjustmentAmt, setSearchByAdjustmentAmt] = useState("");
    const [searchBySecPendingAmt, setSearchBySecPendingAmt] = useState("");
    const [searchByOtherAdj, setSearchByOtherAdj] = useState("");

    //   const [selectedTextField, setSelectedTextField] = useState("");
    //   const [selectedValueField, setSelectedValueField] = useState("");
    const [selectedRecValue, setSelectedRecValue] = useState("all"); // Default value is 25
    const [totalRecords, setTotalRecords] = useState(0);
    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState("DOS");

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    //   const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState("-1");
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState("");
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState("");
    const [insOrPatFilter, setInsOrPatFilter] = useState("updatedby");
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] =
        useState("");
    const [selectedViewType, setSelectedViewType] = useState("0");
    //   const [selectedClaimService, setSelectedClaimService] = useState("0");
    const [isClaimClosed, setIsClaimClosed] = useState("false");

    const [claimFilterRecCountsTableData, setClaimFilterRecCountsTableData] =
        useState([]);
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState(
        claimFilterRecCountsTableData,
    );
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState("Test Biller");

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedInsRows, setSelectedInsRows] = useState([]);
    const [selectedSecInsuranceRows, setSelectedSecInsuranceRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState("93");
    //   const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    //   const [billingNpiValue, setBillingNpiValue] = useState("");
    const [claimId, setClaimId] = useState("");
    const [cptCode, setCptCode] = useState("");
    const [dos, setDos] = useState("");
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);
    const [isOpenPrintFilter, setOpenPrintFilter] = useState(false)
    //   const [rcvdwriteOffValue, setRcvdWriteOffValue] = useState("0");

    //   const [claimRecvdChargeValue, setClaimRcvdChargeValue] = useState([]);
    //   const [claimWriteOffValue, setClaimWriteOffvalue] = useState([]);

    //   const [claimSecRecvdChargeValue, setSecClaimRcvdChargeValue] = useState([]);

    //   const [deductibleAmt, setDeductible] = useState([]);
    //   const [patientRes, setPatientRes] = useState([]);
    //   const [adjustmentAmt, setAdjustmentAmt] = useState([]);
    const [secPendingAmt, setsecPendingAmt] = useState([]);
    const [copay, setcopay] = useState([]);

    //   const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [cptChequeNumber, setcptChequeNumber] = useState([]);
    const [cptChequeDate, setCptChequeDate] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [checkDate, setCheckDate] = useState("");
    //   const [formatCheckDate, setFormatCheckDate] = useState("");
    const [claimPayerRefID, setClaimPayerRefID] = useState([]);
    const [claimNotes, setClaimNotes] = useState([]);

    const [cptSecChequeNumber, setcptsecChequeNumber] = useState([]);
    const [cptSecChequeDate, setCptSecChequeDate] = useState([]);
    const [secClaimPayerRefID, setSecClaimPayerRefID] = useState([]);

    //   const [checkEligibilityColor, setCheckEligibilityColor] = useState("");
    const [isLoading, setIsLoading] = useState("");
    const [isInStatus, setIsInStatus] = useState(false);

    //   const [payRefColor, setPayRefColor] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    //   const [prevFilter, setPrevFilter] = useState("");
    //   const [queryFilter, setQueryFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] =
        useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] =
        useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    //   const [selectedData, setSelectedData] = useState("");
    const [isPageLoad, setisPageLoad] = useState("1");
    const [searchByClaimDos, setSearchByClaimDos] = useState("");

    const [showDataModal, setShowDataModal] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [selectedClaimID, setselectedClaimID] = useState([]);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [reGenerateData, setReGenerateData] = useState(false);
    const [rowState, setRowState] = useState({});
    //   const [isHidden, setIsHidden] = useState(false);
    const [selectedPatname, setselectedPatname] = useState("");
    const [selectedDOB, setselectedDOB] = useState("");
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [searchByLocation, setSearchByLocation] = useState("");
    const [claimID, setClaimID] = useState("");
    const [activeCounts, setActiveCounts] = useState(null);
    const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
    const [errorMessage, setErrorMessage] = useState("");
    const [showCopaySuccessModal, setShowCopaySuccessModal] = useState(false);
    const [selectedMacro, setselectedMacro] = useState("0");

    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
    const [categoryFilteredClaims, setCategoryFilteredClaims] = useState([]);
    const [allClaims, setAllClaims] = useState([]);
    const tableContainerRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const { InsID } = useParams();
    const location = useLocation();
    const [searchBySUD, setSearchBySUD] = useState("");
    const [writeOffInput, setWriteOffInput] = useState("");
    const [adminWriteOffValues, setAdminWriteOffValues] = useState({});
    const queryParams = new URLSearchParams(location.search);
    const fromDate = queryParams.get("startDate");
    const toDate = queryParams.get("endDate");
    const InsName = queryParams.get("InsName");
    const SearchbyFilter = queryParams.get("selectedSearchFilter");
    const [editedValues, setEditedValues] = useState({});
    const [adjustmentCodeData, setadjustmentCodeData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]);
    const [showattachmentData, setShowAttachmentData] = useState(false);
    const [attachmentClaimID, setattachmentClaimID] = useState("");
    const printColumnsConfig = [
  { key: "index", label: "#", render: (_, i) => i + 1 },
  { key: "LocationNickname", label: "Location", render: item => item.LocationNickname || "" },
  {
    key: "ClaimDOS",
    label: "DOS",
    render: item =>
      typeof formatDOSDate === "function"
        ? formatDOSDate(item.ClaimDOS || item.AppointmentDate)
        : item.ClaimDOS || item.AppointmentDate || ""
  },
  { key: "ClaimId", label: "Claim ID", render: item => item.ClaimId || "" },
  {
    key: "PatientName",
    label: "Patient Name",
    render: item =>
      `${item.LastName || ""}${item.LastName && item.FirstName ? ", " : ""}${item.FirstName || ""}`
  },
  { key: "ClaimConType", label: "BH/SUD", render: item => item.ClaimConType || "" },
  {
    key: "DOB",
    label: "DOB",
    render: item =>
      typeof formatSubmitDate === "function"
        ? formatSubmitDate(item.DOB)
        : item.DOB || ""
  },
  {
    key: "InsurancePri",
    label: "Insurance (Pri)",
    render: item =>
      [
        item.InsCompNickName || item.Payer,
        item.PayerID,
        item.PolicyNumber
      ]
        .filter(Boolean)
        .join("\n")
  },
  {
    key: "InsuranceSec",
    label: "Insurance (Sec)",
    render: item =>
      [
        item.SecInsCompNickName || item.SecPayer,
        item.SecPayerID,
        item.SecInsPolicyNumber
      ]
        .filter(Boolean)
        .join("\n")
  },
  {
  key: "ClearingHouseName",
  label: "Clearing House",
  render: item => item.ClearingHouseName ?? ""
},
{
  key: "SubmitDate",
  label: "Submit Date (Pri)",
  render: item => formatSubmitDate(item.SubmitDate)
},
{
  key: "SecClaimSubmiDate",
  label: "Submit Date (Sec)",
  render: item => formatSubmitDate(item.SecClaimSubmiDate)
},
{
  key: "ClaimStatus",
  label: "Status",
  render: item => {
    const priStatus = item.PrimaryPaymentStatus
      ? removeHtmlTags(item.PrimaryPaymentStatus)
      : "";
    const secStatus = item.SecPaymentStatus
      ? removeHtmlTags(item.SecPaymentStatus)
      : "";
    return [priStatus, secStatus]
      .filter(Boolean)
      .join(" ");
  }
},
  { key: "CPT", label: "CPT", render: item => item.CPTOld || item.EncCPT || item.CPTCode1 || "" },
  { key: "Units", label: "Units", render: item => item.Units ?? "" },
  { key: "TotalCharge", label: "Total Charge", render: item => item.totalcharge ?? "" },
  {
    key: "RecvdPri",
    label: "Recvd Charge (Pri)",
    render: item =>
      item.recvdCharge !== undefined && item.recvdCharge !== null
        ? item.recvdCharge
        : ""
  },
  {
    key: "RecvdSec",
    label: "Recvd Charge (Sec)",
    render: item =>
      item.SecrecvdCharge !== undefined && item.SecrecvdCharge !== null
        ? item.SecrecvdCharge
        : ""
  },
  { key: "Adjustment", label: "Contractual Adjustment", render: item => item.Adjustment ?? "" },
  {
  key: "SecPendingAmt",
  label: "Secondary Pending",
  render: item => item.SecPendingAmt ? `$${Number(item.SecPendingAmt).toFixed(2)}` : 0
},
  { key: "Deductible", label: "Deductible", render: item => item.Deductible ?? "" },
  { key: "PatientAmount", label: "Patient Responsibility", render: item => item.PatientAmount ?? "" },
{
  key: "Copay",
  label: "Copay",
  render: item => {
    const copay = item.Copay ?? "0";
    const copayAmount = item.CopayAmount ?? "";
    if (copayAmount) {
      return `${copay} (${copayAmount})`;
    }
    return copay;
  }
},
  { key: "OtherAdjustment", label: "OtherAdjustment", render: item => item.OtherAdjustment ?? "" },
  { key: "FederalPayment", label: "Federal Reduction", render: item => item.FederalPayment ?? "" },
  { key: "WriteOffAmount", label: "WriteOff Amount", render: item => item.WriteOffAmount ?? "" },
  { key: "AdminWriteOff", label: "Admin Write-off", render: item => item.AdminWriteOff ?? "" },
  { key: "Balance", label: "Balance", render: item => item.claimbln ?? "" },
  {
  key: "PaymentChqueNo",
  label: "Cheque # (Pri)",
  render: item => item.PaymentChqueNo || ""
},
{
  key: "PaymentChequeDate",
  label: "Cheque Date (Pri)",
  render: item =>
    typeof formatDateForInput === "function"
      ? formatDateForInput(item.PaymentChequeDate)
      : item.PaymentChequeDate || ""
},
{
  key: "PayerRefNumber",
  label: "Payer Ref # (Pri)",
  render: item => item.PayerRefNumber || ""
},
{
  key: "SecCPTChequeNumber",
  label: "Cheque # (Sec)",
  render: item => item.SecCPTChequeNumber || ""
},
{
  key: "SecCPTChequeDate",
  label: "Cheque Date (Sec)",
  render: item =>
    typeof formatDateForInput === "function"
      ? formatDateForInput(item.SecCPTChequeDate)
      : item.SecCPTChequeDate || ""
},
{
  key: "SecPayerclaimRefNumber",
  label: "Payer Ref # (Sec)",
  render: item => item.SecPayerclaimRefNumber || ""
},
  { key: "Provider", label: "Provider", render: item => item.providername || item.RenderingProvider || "" },
  { key: "UpdatedBy", label: "Updated By", render: item => item.UpdaterName ?? "" },
  { key: "SubmittedBy", label: "Submitted By", render: item => item.SubmitterName ?? "" },
  {
    key: "AdjustmentCodes",
    label: "Adj/Denial/Rejection Codes",
    render: item =>
      getClaimAdjustment(item.ClaimId, item.ClaimCPT)
        ?.map(code => code.ClaimAdjustmentCode)
        ?.join(", ") || ""
  },
  { key: "Remarks", label: "Remarks", render: item => item.Remarks ?? "" },
  { key: "ErrorDetails", label: "Error Details", render: item => item.ErrorDetails ?? "" },
  { key: "Attachments", label: "Attachments", render: item => item.Attachments || "" },
  {
    key: "VerifiedBy",
    label: "Verified By",
    render: item =>
      typeof getVerifiedBy === "function"
        ? getVerifiedBy(item.verifiedBy)
        : item.verifiedBy || ""
  },
  { key: "Notes", label: "Notes", render: item => item.ClaimNotes ?? "" }
];
    const [printColumnVisibility, setPrintColumnVisibility] = useState(
        printColumnsConfig.reduce((acc, col) => {
            acc[col.key] = true;
            return acc;
        }, {})
    );
    useEffect(() => {
        if (InsID && fromDate && toDate) {
            setSInsID(InsID);
            setStartDate(fromDate);
            setEndDate(toDate);
            setSPatID(InsID);
            setSearchText(InsName);
            setSelectedSearchFilter(3);
            setInsOrPatFilter(SearchbyFilter);

            handleTableDataClick();
        }
    }, [InsID, fromDate, toDate, selectedSearchFilter, InsName]);

    const hashParams = new URLSearchParams(window.location.hash.split("?")[1]);

    const DashFromDate = hashParams.get("FromDate");
    const DashToDate = hashParams.get("ToDate");
    const statusValue = hashParams.get("FilterValue");

    // console.log("DASHDATA>>>>>>>>>", DashFromDate, DashToDate, selectedStatusRadioButton);

    useEffect(() => {
        const hashParams = new URLSearchParams(window.location.hash.split("?")[1]);
        const DashFromDate = hashParams.get("FromDate");
        const DashToDate = hashParams.get("ToDate");
        const statusValue = hashParams.get("FilterValue");

        if (DashFromDate && DashToDate && statusValue) {
            setStartDate(DashFromDate);
            setEndDate(DashToDate);
            setSelectedStatusRadioButton(statusValue);
            handleTableDataClick();
        }
    }, [
        DashFromDate,
        DashToDate,
        statusValue,
        selectedStatusRadioButton,
        startDate,
        endDate,
    ]);

    const sAuthToken = useSelector((state) => state.user.token);

    const loadMoreRecords = useCallback(() => {
        setVisibleRecords((prev) => {
            const next = Math.min(prev + rowsPerPage, displayedRecords.length);

            if (next > prev) {
                setPopupMessage(
                    `${next} records out of ${displayedRecords.length} loaded`,
                );
                setShowPopup(true);

                setTimeout(() => {
                    setShowPopup(false);
                }, 3000);
            }

            return next;
        });
    }, [displayedRecords.length]);

    const handleScroll = useCallback(() => {
        const isAtBottom =
            window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight;

        if (isAtBottom) {
            loadMoreRecords();
        }
    }, [loadMoreRecords]);

    useEffect(() => {
        setVisibleRecords(rowsPerPage);
    }, [displayedRecords]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    const [totals, setTotals] = useState({
        allClaims: 0,
        totalUnits: 0,
        totalSubmitted: 0,
        totalReceived: 0,
        totalSecReceived: 0,
        totalAdjustmentAmt: 0,
        totalSecPendingAmt: 0,
        totalDeductible: 0,
        totalPatientRes: 0,
        totalWriteOff: 0,
        totalAdminWriteOff: 0,
        totalBalance: 0,
        totalCopay: 0,
        totalOtherAdjustment: 0,
        totalFederalReduction: 0,
    });

    const [totalsClaims, setTotalsClaims] = useState({
        allClaims: 0,
        totalSubmitClaim: 0,
        totalNonSubmitted: 0,
        totalSent: 0,
        totalForwarded: 0,
        totalReceivedClaim: 0,
        totalSecReceivedClaim: 0,
        totalDeductibleClaim: 0,
        totalPosted: 0,
        totalPaid: 0,
        totalRejected: 0,
        totalDenied: 0,
    });

    const dispatch = useDispatch();

    const userData = useSelector((state) => state.user.user);

    localStorage.setItem("userData2", JSON.stringify(userData));

    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    useEffect(() => {
        document.title = "Claim Status";

        const initialCheckedServices = claimservices.map((item) => item.ServiceID);
        setCheckedServices(initialCheckedServices);
        setShowServiceErrorModal(false);
    }, [claimservices]);

    useEffect(() => {
        const selectedIds = checkedServices.filter((id) => id !== 0);
        setSelectedServiceIDs(selectedIds);
        setShowServiceErrorModal(false);
    }, [checkedServices]);

    const handleClaimServiceChange = (item) => {
        if (item.ServiceID === "0") {
            setCheckedServices(
                isNoServiceChecked
                    ? []
                    : claimservices.map((service) => service.ServiceID),
            );
        } else {
            const updatedServices = checkedServices.includes(item.ServiceID)
                ? checkedServices.filter((selectedId) => selectedId !== item.ServiceID)
                : [...checkedServices, item.ServiceID];
            setCheckedServices(updatedServices);
        }
        updateSelectedServiceIds();
    };

    const updateSelectedServiceIds = () => {
        const selectedIds = checkedServices.includes("0")
            ? checkedServices.filter((id) => id !== "0")
            : checkedServices;

        setSelectedServiceIDs(selectedIds);
    };

    useEffect(() => {
        let timerId;

        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);
            }, successTimer);
        }

        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);

    const modalRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowConfirmSaveModal(false);
            }
        };

        // Add event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, "MM/dd/yyyy");
            setStartDate(formattedDate);
            setIsStartOpen(false);
        } else {
            setStartDate(null);
        }
    };

    const handleEndDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, "MM/dd/yyyy");
            setEndDate(formattedDate);

            setIsEndOpen(false);
        } else {
            setEndDate(null);
        }
    };

    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), "MMMM")}
                </option>
            );
        }).filter((option) => option !== null);
    };

    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);

            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };

    const CalendarContainer = ({ children }) => (
        <div
            style={{
                zIndex: "99px",
                backgroundColor: "white",
                border: "1px solid lightgray",
            }}
        >
            {children}
            <div
                style={{
                    justifyContent: "center",
                    padding: "10px",
                    borderTop: "1px solid #ddd",
                    marginLeft: "65px",
                }}
            >
                <button
                    type="button"
                    className="today-btn"
                    onClick={() => handleTodayClick("end")}
                >
                    Today
                </button>
            </div>
        </div>
    );

    const CalendarStartContainer = ({ children }) => (
        <div
            style={{
                zIndex: "99px",
                backgroundColor: "white",
                border: "1px solid lightgray",
            }}
        >
            {children}
            <div
                style={{
                    justifyContent: "center",
                    padding: "10px",
                    borderTop: "1px solid #ddd",
                    marginLeft: "65px",
                }}
            >
                <button
                    type="button"
                    className="today-btn"
                    onClick={() => handleTodayClick("start")}
                >
                    Today
                </button>
            </div>
        </div>
    );

    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) !== null;
    };

    // Function to format dates as "yyyy-MM-dd"
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split("-");
        const formattedMonth = month.padStart(2, "0");
        const formattedDay = day.padStart(2, "0");
        return `${year}-${formattedMonth}-${formattedDay}`;
    };

    const handleHideCheckboxChange = () => {
        setIsHideChecked(!isHideChecked);

        if (isHideChecked) {
            // Reset to original dates
            setStartDate(formatCurDate);
            setEndDate(formatCurDate);
        } else {
            // Set FROM date to 1/1/2015 and TO date to the current date
            setStartDate("1/1/2015");
            setEndDate(formatCurDate);
        }
    };

    // Api Integration of all Dropdowns

    useEffect(() => {
        const storedSelectedStatusRadioButton = localStorage.getItem(
            "selectedStatusRadioButton",
        );
        if (storedSelectedStatusRadioButton) {
            setSelectedStatusRadioButton(storedSelectedStatusRadioButton);
        }

        // Load stored userData from localStorage on component mount
        // const storedUserData = localStorage.getItem('userData');
        // var inputStruct = {

        //     LoggedInUserDetails: userData

        // }

        var myInput = { sInputJSON: JSON.stringify(userData) };

        myInput = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimApprovalConstants.GetClaimDropDowns,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInput,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response
                const parsedData = JSON.parse(data.d);
                const dropdownData = parsedData.Data;

                // setSelectAllDropdown(dropdownData);
                // Populate the dropdowns with the received data
                setLocations(dropdownData.LocationDetails);

                // setCMS33aData(dropdownData.CMSbox33aData);
                // setCMS33bData(dropdownData.CMSbox33bData);
                // setBillingNPIs(dropdownData.PracticeBillingNPIs);
                // setServiceLocations(dropdownData.ServiceLocation);
                // setPracticeProvider(dropdownData.PracticeProviders);
                // setProviderCategory(dropdownData.ProvidersCategories);
                // setSearchFilterData(dropdownData.SearchByFilters);
                // setStatusRadioButton(dropdownData.StatusRadioButtons);
                // setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
                setLoading(false);
            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    }, [userData]);

    //Fetch the All claim status services

    useEffect(() => {
        var inputStruct = {
            sPracticeID: userPracticeID,
        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimStatusConstants.GetClaimServices,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data.d);
                const serviceData = parsedData.Data;
                setClaimServices(parsedData);
            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    }, []);

    //Fetch the data of Practice Billing NPIs
    useEffect(() => {
        var inputStruct = {
            LoggedInUserDetails: userData,
        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimStatusConstants.GetPracticeBillingNPIs,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data.d);
                const practiceData = parsedData.Data;

                setPracticeBillingNPIs(practiceData);
            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    }, []);

    const handleLocationChange = (e, item) => {
        const newSelectedLocation = e.target.value;
        setSelectedLocation(newSelectedLocation || item.LocationId);
        setSelectLocationID(newSelectedLocation || item.LocationId);

        localStorage.setItem("selectedLocation", newSelectedLocation);
    };

    const handleRadioButtonsChange = (e) => {
        setSelectedStatusRadioButton(e.target.value);
        localStorage.setItem("selectedStatusRadioButton", e.target.value);
        const selectedValue = e.target.value;
        setsClaimStatus(selectedValue);
    };

    useEffect(() => {
        setsClaimStatus(selectedStatusRadioButton);
        //handleTableDataClick();
    }, [selectedStatusRadioButton, sClaimStatus]);

    const fetchPatientNames = () => {
        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchText,
            SearchBy: 0,
            isFromLogin: 0,
        };

        var sJSONInput = JSON.stringify(inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data;

                if (Array.isArray(patientData)) {
                    setSuggestions(
                        patientData.map((item) => ({
                            label: `${item.LastName}, ${item.FirstName}`,
                            val: item.PatientID,
                        })),
                    );
                } else {
                    setSuggestions([]);

                    setIsTextBoxDisabled(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching patient names:", error);
            });
    };

    const fetchUpdatedBy = () => {
        var inputStruct = {
            sPracticeID: userPracticeID,
            sUserID: userId,
            srchKey: searchText,
        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const suggestionData = parsedData.Data;

                if (suggestionData.length > 0) {
                    setSuggestions(
                        suggestionData.map((item) => ({
                            label: item.split("$")[1],
                            val: item.split("$")[0],
                        })),
                    );

                    const defaultSuggestion = suggestionData.find(
                        (item) => item === defaultUpdatedBy,
                    );
                    if (defaultSuggestion) {
                        setSearchText({
                            label: defaultSuggestion.split("$")[1],
                            val: defaultSuggestion.split("$")[0],
                        });
                    }
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching provider names:", error);
            });
    };

    const fetchSubmittedBy = () => {
        var inputStruct = {
            sPracticeID: userPracticeID,
            sUserID: userId,
            srchKey: searchText,
        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const suggestionData = parsedData.Data;

                if (suggestionData.length > 0) {
                    setSuggestions(
                        suggestionData.map((item) => ({
                            label: item.split("$")[1],
                            val: item.split("$")[0],
                        })),
                    );
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching provider names:", error);
            });
    };

    const fetchSearchProviders = () => {
        // if (!searchProvidersText) {
        //     //If searchText is empty, you may want to reset or clear any existing data
        //     setSearchPatientData([]);
        //     setIsSuggestionBoxDisabled(true);// Disable suggestion box if needed
        //     return;
        // }

        var inputStruct = {
            sProviderName: searchText,
            sPracticeID: userPracticeID,
            LoggedInUserDetails: userData,
        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const providersData = parsedData.Data;

                if (Array.isArray(providersData)) {
                    setSuggestions(
                        providersData.map((item) => ({
                            label: item.split("$")[0].split("|")[1].trim(),
                            val: item.split("$")[1].trim(),
                        })),
                    );
                } else {
                    setSuggestions([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching provider names:", error);
            });
    };

    const fetchInsuranceCompanies = () => {
        var inputJSON = {
            SearchKey: searchText,
        };

        var sJSONInput = JSON.stringify(inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                const parsedData = JSON.parse(data);

                const InsuranceData = parsedData.Data;

                if (Array.isArray(InsuranceData)) {
                    const filteredSuggestions = InsuranceData.map((item) => ({
                        label: item.Insurance,
                        val: item.InsuID,
                    }));

                    const filteredData = filteredSuggestions.filter((ins) =>
                        ins.label.toLowerCase().includes(searchText.toLowerCase()),
                    );

                    setSuggestions(filteredData);
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }

                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error("Error fetching Insurance names:", error);
                setSuggestions([]);
            });

        return [];
    };

    const fetchClearingHouse = () => {
        var inputJSON = {
            SearchKey: searchText,
        };

        var sJSONInput = JSON.stringify(inputJSON);

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetClearingHouse}?sJSONInput=${sJSONInput}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                const parsedData = JSON.parse(data);

                // console.log("HOUSE", parsedData);

                if (Array.isArray(parsedData)) {
                    const filteredSuggestions = parsedData.map((item) => ({
                        label: item.ClearingHouseName,
                        val: item.MCHID,
                    }));

                    const filteredData = filteredSuggestions.filter((item) =>
                        item.label.toLowerCase().includes(searchText.toLowerCase()),
                    );

                    setSuggestions(filteredData);
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }

                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error("Error fetching Insurance names:", error);
                setSuggestions([]);
            });

        return [];
    };

    //Fetch CPT List

    useEffect(() => {
        fetchCPTList(selectedCptValue);
    }, [selectedCptValue]);

    const cptRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                cptRef.current &&
                !cptRef.current.contains(event.target) &&
                event.target.tagName !== "INPUT" &&
                event.target.tagName !== "SELECT"
            ) {
                setCptValueList([]);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const fetchCPTList = (searchKey) => {
        if (!searchKey) {
            setCptValueList([]);
            return;
        }

        const inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchKey,
        };

        const sJSONInput = JSON.stringify(inputJSON);
        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data);
                const filteredData = parsedData.filter(
                    (item) => `${item.CPTCode}` !== selectedCptValue,
                );
                setCptValueList(filteredData);
            })
            .catch((error) => {
                console.error("Error fetching CPT names:", error);
            });
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedCptValue(value);
        fetchCPTList(value);
    };

    const handleKeyCPTDown = (e) => {
        if (e.key === "Backspace") {
            const newVal = selectedCptValue.slice(0, -1);
            setSelectedCptValue(newVal);
            fetchCPTList(newVal);
        }

        if (["Enter", "Escape", "Tab"].includes(e.key)) {
            setCptValueList([]);
        }
    };

    // Handle list selection
    const handleCPTList = (suggestion) => {
        setSelectedCptValue(suggestion.CPTCode);
        setSelectedCPTCode(suggestion.CPTCode);
        setselectedMacro(suggestion.IsMacro);
        setCptValueList([]);
    };

    //   const handleSelectBillingNPI = (event) => {
    //     const selectedValue = event.target.value;
    //     setSelectedBillingNPI(selectedValue);
    //   };

    // const filteredProviders = practiceProvider.filter(provider => provider.Supervisor === '1' || provider.Supervisor === '3');

    const handleSelectFilterProviders = (event) => {
        const selectedValue = event.target.value;
        setSelectedFilterProvider(selectedValue);
    };

    //   const [selectedProvider, setSelectedProvider] = useState("");
    //   const [tdata, setTdata] = useState("");

    // Function to handle checkbox change
    //   const handleCheckboxChange = (e) => {
    //     const value = e.target.checked ? 1 : 0; // Set 1 if checked, 0 if unchecked
    //     setIsChecked(value);
    //   };

    useEffect(() => {
        // setSelectedCheckedRadioButton("0");
        setSelectedStatusRadioButton("0");
    }, []);

    //   const handleRadioChange = (e) => {
    //     setSelectedCheckedRadioButton(e.target.value);
    //   };

    //   const processTableData = () => {
    //     tableDetails.forEach((item) => {
    //       setRowsValidation(item.DataValidationMessage);
    //     });
    //   };

    useEffect(() => {
        if (selectedRecValue === "all") {
            setDisplayedRecords(filteredTableDetails);
        } else {
            setDisplayedRecords(filteredTableDetails.slice(0, selectedRecValue));
        }
    }, [filteredTableDetails, selectedRecValue]);

    useEffect(() => {
        if (displayedRecords && Array.isArray(displayedRecords)) {
            setTotalRecords(displayedRecords.length);
        } else {
            setTotalRecords(0);
        }
    }, [displayedRecords]);

    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectedRecValue(value);
    };

    //Get all total Records of Main Table

    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === "string") {
                const cleanedAmount = amount.replace(/\$/g, "").trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === "number") {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotals({
            totalUnits: 0,
            totalSubmitted: 0,
            totalReceived: 0,
            totalWriteOff: 0,
            totalAdminWriteOff: 0,
            totalAdjustmentAmt: 0,
            totalSecPendingAmt: 0,
            totalBalance: 0,
            totalSecReceived: 0,
            totalDeductible: 0,
            totalPatientRes: 0,
            totalCopay: 0,
            totalOtherAdjustment: 0,
            totalFederalReduction: 0,
        });

        // Loop through displayedRecords to calculate new totals
        displayedRecords.forEach((claim) => {
            const curRowunits = claim["Units"]?.trim();
            const curRowCharges = claim["totalcharge"];
            const totalReceived = claim["recvdCharge"];
            const curRowWriteOff = claim["WriteOffAmount"];
            const curRowBalance = claim["claimbln"];
            const AdminWriteOff = claim["AdminWriteOff"];
            const totalDeductible = claim["Deductible"];
            const totalSecReceived = claim["SecrecvdCharge"];
            const PatientRes = claim["PatientAmount"];
            const AdjustmentAmt = claim["Adjustment"];
            const SecPendingAmt = claim["SecPendingAmt"];
            const CopayAmt = claim["Copay"];
            const OtherAdjustment = claim["OtherAdjustment"];
            const FederalReduction = claim["FederalReduction"];

            if (curRowunits !== undefined && curRowunits !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalUnits: prevTotals.totalUnits + parseInt(curRowunits),
                }));

            if (curRowCharges !== undefined && curRowCharges !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalSubmitted:
                        prevTotals.totalSubmitted + parseAmount(curRowCharges),
                }));

            if (totalReceived !== undefined && totalReceived !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalReceived: prevTotals.totalReceived + parseAmount(totalReceived),
                }));

            if (totalSecReceived !== undefined && totalSecReceived !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalSecReceived:
                        prevTotals.totalSecReceived + parseAmount(totalSecReceived),
                }));

            if (AdjustmentAmt !== undefined && AdjustmentAmt !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalAdjustmentAmt:
                        prevTotals.totalAdjustmentAmt + parseAmount(AdjustmentAmt),
                }));

            if (CopayAmt !== undefined && CopayAmt !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalCopay: prevTotals.totalCopay + parseAmount(CopayAmt),
                }));

            if (OtherAdjustment !== undefined && OtherAdjustment !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalOtherAdjustment:
                        prevTotals.totalOtherAdjustment + parseAmount(OtherAdjustment),
                }));

            if (FederalReduction !== undefined && FederalReduction !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalFederalReduction:
                        prevTotals.totalFederalReduction + parseAmount(FederalReduction),
                }));

            if (SecPendingAmt !== undefined && SecPendingAmt !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalSecPendingAmt:
                        prevTotals.totalSecPendingAmt + parseAmount(SecPendingAmt),
                }));

            if (totalDeductible !== undefined && totalDeductible !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalDeductible:
                        prevTotals.totalDeductible + parseAmount(totalDeductible),
                }));

            if (PatientRes !== undefined && PatientRes !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalPatientRes: prevTotals.totalPatientRes + parseAmount(PatientRes),
                }));

            if (curRowWriteOff !== undefined && curRowWriteOff !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalWriteOff: prevTotals.totalWriteOff + parseAmount(curRowWriteOff),
                }));

            if (AdminWriteOff !== undefined && AdminWriteOff !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalAdminWriteOff:
                        prevTotals.totalAdminWriteOff + parseAmount(AdminWriteOff),
                }));

            if (curRowBalance !== undefined && curRowBalance !== "")
                setTotals((prevTotals) => ({
                    ...prevTotals,
                    totalBalance: prevTotals.totalBalance + parseAmount(curRowBalance),
                }));
        });
    }, [displayedRecords]);

    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === "string") {
                const cleanedAmount = amount.replace(/\$/g, "").trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === "number") {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotalsClaims({
            allClaims: 0,
            totalSubmitClaim: 0,
            totalNonSubmitted: 0,
            totalSent: 0,
            totalForwarded: 0,
            totalReceivedClaim: 0,
            totalPosted: 0,
            totalPaid: 0,
            totalRejected: 0,
            totalDenied: 0,
            totalCopay: 0,
        });

        // Loop through claimRecCountsTableData to calculate new totals
        claimRecCountsTableData.forEach((claim) => {
            const allClaims = claim["AllClaims"];
            const totalSubmitClaim = claim["Submitted"]?.trim();
            const totalNonSubmitted = claim["NonSubmitted"];
            const totalSent = claim["SENT"];
            const totalForwarded = claim["FORWARDED"];
            const totalReceivedClaim = claim["PaymentReceived"];
            const totalPosted = claim["PaymentPosted"];
            const totalPaid = claim["PAID"];
            const totalRejected = claim["REJECTED"];
            const totalDenied = claim["DENIED"];

            if (allClaims !== undefined && allClaims !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    allClaims: prevTotals.allClaims + parseInt(allClaims),
                }));

            if (totalSubmitClaim !== undefined && totalSubmitClaim !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalSubmitClaim:
                        prevTotals.totalSubmitClaim + parseInt(totalSubmitClaim),
                }));

            if (totalNonSubmitted !== undefined && totalNonSubmitted !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalNonSubmitted:
                        prevTotals.totalNonSubmitted + parseAmount(totalNonSubmitted),
                }));

            if (totalSent !== undefined && totalSent !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalSent: prevTotals.totalSent + parseAmount(totalSent),
                }));

            if (totalForwarded !== undefined && totalForwarded !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalForwarded:
                        prevTotals.totalForwarded + parseAmount(totalForwarded),
                }));

            if (totalReceivedClaim !== undefined && totalReceivedClaim !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalReceivedClaim:
                        prevTotals.totalReceivedClaim + parseAmount(totalReceivedClaim),
                }));

            if (totalPosted !== undefined && totalPosted !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalPosted: prevTotals.totalPosted + parseAmount(totalPosted),
                }));

            if (totalPaid !== undefined && totalPaid !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalPaid: prevTotals.totalPaid + parseAmount(totalPaid),
                }));

            if (totalRejected !== undefined && totalRejected !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalRejected: prevTotals.totalRejected + parseAmount(totalRejected),
                }));

            if (totalDenied !== undefined && totalDenied !== "")
                setTotalsClaims((prevTotals) => ({
                    ...prevTotals,
                    totalDenied: prevTotals.totalDenied + parseAmount(totalDenied),
                }));
        });

        // ReloadClaimsData('all')
    }, [claimRecCountsTableData]);

    // Fetch all Transaction Codes

    useEffect(() => {
        var inputStruct = {};

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimStatusConstants.GetTransactionCode,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data.d);

                setTransactionCodes(parsedData);
               
            })

            .catch((error) => {
                console.error("Error fetching data: ", error);
            });
    }, []);

    //Filtered the data based on Checkboxes in MainTable

    useEffect(() => {
        let filteredClaimsList = [];

        if (isClaimChecked) {
            var allClaims = [...tableDetails];
            filteredClaimsList = filteredClaimsList.concat(allClaims);
        } else {
            if (isNonSubmitChecked) {
                const nonSubClaims = tableDetails.filter(
                    (claims) => claims.SubmitDate === "",
                );
                filteredClaimsList = filteredClaimsList.concat(nonSubClaims);
            }

            if (isSubmitChecked) {
                const submittedClaims = tableDetails.filter(
                    (claims) => claims.SubmitDate !== "",
                );
                filteredClaimsList = filteredClaimsList.concat(submittedClaims);
            }

            if (isSentChecked) {
                const sentClaims = tableDetails.filter(
                    (claims) => claims.ClaimStatusInt === 3,
                );
                filteredClaimsList = filteredClaimsList.concat(sentClaims);
            }

            if (isForwardChecked) {
                const fwdClaims = tableDetails.filter(
                    (claims) => claims.ClaimStatusInt === 5,
                );
                filteredClaimsList = filteredClaimsList.concat(fwdClaims);
            }

            if (isRecvdChecked) {
                const paymentRecvdClaims = tableDetails.filter(
                    (claims) => claims.isPaymentReceived,
                );
                filteredClaimsList = filteredClaimsList.concat(paymentRecvdClaims);
            }

            if (isPaidChecked) {
                const paidClaims = tableDetails.filter(
                    (claims) => claims.ClaimStatusInt == 1,
                );
                filteredClaimsList = filteredClaimsList.concat(paidClaims);
            }

            if (isRejectedChecked) {
                const rejectedClaims = displayedRecords.filter(
                    (claims) => claims.ClaimStatusInt == 2,
                );
                filteredClaimsList = filteredClaimsList.concat(rejectedClaims);
            }

            if (isDeniedChecked) {
                const deniedClaims = displayedRecords.filter(
                    (claims) => claims.isDenied == 1,
                );
                filteredClaimsList = filteredClaimsList.concat(deniedClaims);
            }
        }

        setDisplayedRecords(filteredClaimsList);
    }, [
        isClaimChecked,
        isNonSubmitChecked,
        isSubmitChecked,
        isSentChecked,
        isForwardChecked,
        isRecvdChecked,
        isPaidChecked,
        isRejectedChecked,
        isDeniedChecked,
    ]);

    const handleInputKeyPress = (event) => {
        if (event.key === "Backspace") {
            // Handle backspace key
            if (searchText === "" && suggestions.length > 0) {
                setSuggestions([]);
            } else {
                //  Remove the last character from searchText
                const updatedSearchText = searchText.slice(0, -1);

                if (selectedSearchFilter === "pat") {
                    fetchPatientNames(updatedSearchText);
                } else if (selectedSearchFilter === "updatedby") {
                    fetchUpdatedBy(updatedSearchText);
                } else if (selectedSearchFilter === "ins") {
                    fetchInsuranceCompanies(updatedSearchText);
                } else if (selectedSearchFilter === "submittedby") {
                    fetchSubmittedBy(updatedSearchText);
                } else if (selectedSearchFilter === "renderingprovider") {
                    fetchSearchProviders(updatedSearchText);
                } else if (selectedSearchFilter === "ch") {
                    fetchClearingHouse(updatedSearchText);
                }
            }
        }
    };

    useEffect(() => {
        // Set the default last 7 days' date range
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);

        setStartDate(sevenDaysAgo);
        setEndDate(today);

        setSearchText(userData.userFullName);
        setSPatID(userData.userID);

        setisPageLoad(1);
    }, []);

    //Bind the approval table details

    const handleTableDataClick = (DataValidationMessage, selectedServiceIDs) => {
        setLoading(true);
        setActiveCounts(null);

        setSelectedAdminWriteRows([]);
        setSelectedPolicyRows([]);
        setSelectedWriteOffRows([]);
        setSelectedResubmitRows([]);

        setIsClaimChecked(true);
        setIsSubmitChecked(true);
        setIsNonSubmitChecked(true);
        setIsSentChecked(true);
        setIsForwardChecked(true);
        setIsRecvdChecked(true);
        setIsPostedChecked(true);
        setIsPaidChecked(true);
        setIsRejectedChecked(true);
        setIsDeniedChecked(true);

        if (checkedServices.length == 0) {
            setShowServiceErrorModal(true);
        } else {
            const sFilterType = selectedDropdownValue;
            var MissingData = DataValidationMessage;

            //   if (MissingData != "") {
            //     console.log("Datavalid", MissingData);
            //   }

            var strCPTGroups = [];

            var objInput = {
                iPracticeID: userPracticeID + "",
                sFromDate: startDate,
                sToDate: endDate,
                sFilterType: sFilterType,
                sPatientID: sPatID,
                sInsuranceID: sInsID,
                sCPT: selectedCptValue,
                sInsorPatFilter: insOrPatFilter,
                sLocationID: selectLocationID,
                sFilterText: searchText + "",
                ViewType: selectedViewType,
                isClosedClaims: isClaimClosed,
                sService: selectedServiceIDs,
                sCPTGroups: strCPTGroups,
                sClaimStatus: sClaimStatus,
                sDefaultSearch: true,
                roleID: userData.roleID,
                isMacro: selectedMacro,
                iProviderTemplateID: userData.iProviderTemplateID,
                DefaultTimeZoneOffSet: userData.DefaultTimeZoneOffSet,
            };

            var myInput = JSON.stringify({ ObjClaims: objInput });

            //   console.log(
            //     "Input of" + ClaimStatusConstants.GetClaimStatusData,
            //     myInput,
            //   );

            const url = `${APIConstants.BASE_URL_BILLING}${ClaimStatusConstants.GetClaimStatusData}?sInputJSON=${myInput}`;

            fetch(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sAuthToken}`,
                },
            })
                .then((response) => {
                    if (response.status != 200) {
                        console.log("response.status", response.status);
                    } else return response.json();
                })

                .then((data) => {
                    const parsedTableData = JSON.parse(data);
                    const tableData = parsedTableData.Data[0];

                    setTableDetails(tableData);
                    setadjustmentCodeData(parsedTableData.Data[2]);
                    console.log(
                         "Response of" + ClaimStatusConstants.GetClaimStatusData,
                        parsedTableData,
                      );
                    setTimeout(() => {
                        setLoading(false);
                        setFilteredTableDetails(tableData);
                    }, 10);

                    const claimCountsData = parsedTableData.Data[1];
                    setClaimFilterRecCountsTableData(claimCountsData);
                    setClaimRecCountsTableData(claimCountsData);

                    setShowServiceErrorModal(false);
                })

                .catch((error) => {
                    setError("API request failed");
                    setLoading(false);
                });
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleTableDataClick(0, selectedServiceIDs);
        }
    };

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedServiceIDs, searchText]);

    useEffect(() => {
        if (selectedSearchFilter === "1" && searchText) {
            fetchPatientNames();
        } else if (selectedSearchFilter === "9" && searchText) {
            fetchUpdatedBy();
        } else if (selectedSearchFilter === "3" && searchText) {
            fetchInsuranceCompanies();
        } else if (selectedSearchFilter === "8" && searchText) {
            fetchSubmittedBy();
        } else if (selectedSearchFilter === "5" && searchText) {
            fetchSearchProviders();
        } else if (selectedSearchFilter === "4" && searchText) {
            fetchSubmittedBy();
        } else if (selectedSearchFilter == 10 && searchText) {
            fetchClearingHouse();
        } else if (selectedSearchFilter == 0 && searchText) {
            handleTableDataClick();
        }
    }, [searchText]);

    const handleFilterChange = (event) => {
        setIsTextBoxDisabled(selectedSearchFilter === "");

        setSearchText("");

        setSelectedSearchFilter(event.target.value);
        // if (selectedSearchFilter !== "7") {
        //   setBillingNPIs("");
        // }

        // Default value for Updated By
        if (event.target.value === "9") {
            setInsOrPatFilter("updatedby");
        } else {
            // Handle other filter changes
            switch (event.target.value) {
                case "1":
                    setInsOrPatFilter("pat");
                    break;
                case "2":
                    setInsOrPatFilter("claimId");
                    break;
                case "3":
                    setInsOrPatFilter("ins");
                    break;
                case "4":
                    setInsOrPatFilter("verifiedby");
                    break;
                case "5":
                    setInsOrPatFilter("renderingprovider");
                    break;
                case "6":
                    setInsOrPatFilter("verifiedbyall");
                    break;
                case "7":
                    setInsOrPatFilter("billingnpi");

                    break;
                case "8":
                    setInsOrPatFilter("submittedby");
                    break;
                case "10":
                    setInsOrPatFilter("ch");
                    break;

                case "0":
                    setInsOrPatFilter(" ");
                    break;
                default:
                    break;
            }
        }
    };

    const handleSuggestionSelect = (item) => {
        setSearchText(item.label || item.val);

        setSuggestions([]);

        setSPatID(item.val);
        setSInsID(item.val);
    };

    const hasLoadedInitially = useRef(false);

    useEffect(() => {
        if (!hasLoadedInitially.current) {
            return;
        }

        if (hasLoadedInitially.current) {
            handleTableDataClick(searchText, selectedServiceIDs);
            hasLoadedInitially.current = false;
        }

        handleClaimServiceChange(selectedServiceIDs);
    }, [selectedServiceIDs]);

    useEffect(() => {
        if (isPageLoad && !hasLoadedInitially.current) {
            handleTableDataClick(searchText, selectedServiceIDs);

            hasLoadedInitially.current = true; // Mark the initial load as done
        }
    }, [isPageLoad]);

    const removeHtmlTags = (htmlString) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = htmlString;
        return tempElement.textContent || tempElement.innerText;
    };

    const getClassForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case "N":
                return "not-submit-style";
            case "D":
                return "denied-style";
            case "P":
                return "paid-style";
            case "F":
                return "forwarded-style";
            case "R":
                return "rejected-style";
            case "S":
                return "sent-style";
            default:
                return "";
        }
    };

    const getTitleForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case "N":
                return "Not-Billed";
            case "D":
                return "Denied";
            case "P":
                return "Paid";
            case "F":
                return "Forwarded";
            case "R":
                return "Rejected";
            case "S":
                return "Sent";
            default:
                return "";
        }
    };

    function getTooltip(html) {
        const match = html.match(/data-title=['"]([^'"]+)['"]/);
        return match ? match[1] : "";
    }

    function stripTags(html) {
        return html.replace(/<[^>]*>/g, "");
    }

    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp.substr(6)));
    };

    const handleRowCheckboxChange = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(
                selectedRows.filter((selectedRow) => selectedRow !== index),
            );
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const handleSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) =>
            selectedRows.includes(index),
        );

        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );
        }
    };

    // New function to update "Select All" checkbox state based on individual checkboxes
    const updateSelectAllCheckbox = () => {
        const allSelected = tableDetails.every((_, index) =>
            selectedRows.includes(index),
        );
        const someSelected = selectedRows.length > 0 && !allSelected;

        // Update the "Select All" checkbox based on individual checkboxes
        setSelectAllChecked(allSelected);
    };

    // State for "Select All" checkbox
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    // Use useEffect to update "Select All" checkbox state whenever selectedRows changes
    useEffect(() => {
        updateSelectAllCheckbox();
    }, [selectedRows]);

    useEffect(() => {
        return () => setSelectedPolicyRows([]);
    }, []);

    useEffect(() => {
        setSelectAllChecked(selectedPolicyRows.length > 0);
    }, [selectedPolicyRows]);

    const handlePolicySelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) =>
            selectedPolicyRows.includes(index),
        );
        setSelectedAllChecked((prevChecked) => !prevChecked);

        if (allSelected) {
            // Deselect all

            setSelectedPolicyRows([]);
        } else {
            // Select all checkboxes
            setSelectedPolicyRows(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );
        }
    };

    const handlePolicyRowCheckboxChange = (index) => {
        if (selectedPolicyRows.includes(index)) {
            setSelectedPolicyRows(
                selectedPolicyRows.filter((selectedRow) => selectedRow !== index),
            );
        } else {
            setSelectedPolicyRows([...selectedPolicyRows, index]);
        }
        setSelectAllChecked(false);
    };

    const handleSelectInsuranceAllChange = () => {
        const allSelected = tableDetails.every((_, index) =>
            insuranceAllCheckbox.includes(index),
        );

        if (allSelected) {
            // Deselect all checkboxes
            setInsuranceAllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setInsuranceAllCheckbox(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );

            setSelectedRows(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );
        }
    };

    const handleInsuranceRowCheckbox = (index, item) => {
        setClaimID(item.ClaimId);

        if (insuranceAllCheckbox.includes(index)) {
            // If the row is already selected, unselect it
            setInsuranceAllCheckbox(
                insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index),
            );
            setSelectedInsRows((prevSelectedRows) =>
                prevSelectedRows.filter((selectedRow) => selectedRow !== index),
            );
        } else {
            // If the row is not selected, select it
            setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);
            setSelectedInsRows((prevSelectedRows) => [...prevSelectedRows, index]);
        }
    };

    const handleSelectSecInsuranceAllChange = () => {
        const allSelected = tableDetails.every((_, index) =>
            SecInsuranceAllCheckbox.includes(index),
        );

        if (allSelected) {
            // Deselect all checkboxes
            setSecInsuranceAllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setSecInsuranceAllCheckbox(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );

            setSelectedRows(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );
        }
    };

    const handleSecInsuranceCheckboxChange = (index) => {
        if (SecInsuranceAllCheckbox.includes(index)) {
            setSecInsuranceAllCheckbox(
                SecInsuranceAllCheckbox.filter((selectedRow) => selectedRow !== index),
            );
            setSelectedSecInsuranceRows((prevSelectedRows) =>
                prevSelectedRows.filter((selectedRow) => selectedRow !== index),
            );
        } else {
            setSecInsuranceAllCheckbox([...SecInsuranceAllCheckbox, index]);
            setSelectedSecInsuranceRows((prevSelectedRows) => [
                ...prevSelectedRows,
                index,
            ]);
        }
    };

    // useEffect(() => {

    //     return () => setSelectedWriteOffRows([]);
    // }, []);

    // useEffect(() => {

    //     setSelectAllWriteOffChecked(selectedWriteOffRows.length > 0);
    // }, [selectedWriteOffRows]);

    const handleWriteOffSelectAllChange = () => {
        const openClaims = tableDetails.filter((item) => item.iClosed !== 1);

        const allSelected = openClaims.every((openItem) =>
            selectedWriteOffRows.some(
                (selected) => selected.ClaimId === openItem.ClaimId,
            ),
        );

        if (allSelected) {
            // Deselect all open rows (leave any other selected ones untouched if you like)
            setSelectedWriteOffRows((prev) =>
                prev.filter(
                    (selected) =>
                        !openClaims.some((open) => open.ClaimId === selected.ClaimId),
                ),
            );
            setSelectAllWriteOffChecked(false);
        } else {
            // Select all open claim objects
            setSelectedWriteOffRows(openClaims);
            setSelectAllWriteOffChecked(true);
        }
    };

    // const handleWriteOffRowCheckboxChange = (index) => {

    //     if (selectedWriteOffRows.includes(index)) {
    //         setSelectedWriteOffRows(selectedWriteOffRows.filter((selectedRow) => selectedRow !== index));

    //     } else {
    //         setSelectedWriteOffRows([...selectedWriteOffRows, index]);

    //     }
    //     setSelectAllWriteOffChecked(false);
    // }

    // useEffect(() => {

    //     return () => setSelectedAdminWriteRows([]);
    // }, []);

    useEffect(() => {
        setSelectAllAdminWriteChecked(selectedAdminWriteRows.length > 0);
    }, [selectedAdminWriteRows]);

    const handleAdminSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) =>
            selectedAdminWriteRows.includes(index),
        );
        setSelectAllAdminWriteChecked((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedAdminWriteRows([]);
        } else {
            // Select all checkboxes
            setSelectedAdminWriteRows(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );
        }
    };

    const handleAdminRowCheckboxChange = (index) => {
        if (selectedAdminWriteRows.includes(index)) {
            setSelectedAdminWriteRows(
                selectedAdminWriteRows.filter((selectedRow) => selectedRow !== index),
            );
        } else {
            setSelectedAdminWriteRows([...selectedAdminWriteRows, index]);
        }
        setSelectAllAdminWriteChecked(false);
    };

    // useEffect(() => {

    //     return () => setSelectedResubmitRows([]);
    // }, []);

    useEffect(() => {
        setSelectAllResubmit(selectedResubmitRows.length > 0);
    }, [selectedResubmitRows]);

    const handleResubmitAllChange = () => {
        const allSelected = tableDetails.every((_, index) =>
            selectedResubmitRows.includes(index),
        );
        setSelectAllResubmit((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedResubmitRows([]);
        } else {
            // Select all checkboxes
            setSelectedResubmitRows(
                Array.from({ length: tableDetails.length }, (_, index) => index),
            );
        }
    };

    const handleReSubmitCheckboxChange = (index) => {
        if (selectedResubmitRows.includes(index)) {
            setSelectedResubmitRows(
                selectedResubmitRows.filter((selectedRow) => selectedRow !== index),
            );
        } else {
            setSelectedResubmitRows([...selectedResubmitRows, index]);
        }
        setSelectAllResubmit(false);
    };

    const handleOpenModal = () => {
        setShowConfirmSaveModal(true);
    };

    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
        setShowFaxModal(false);
        setShowDataModal(false);
        setShowCopaySuccessModal(false);
        setShowAttachmentData(false);
    };

    const handleOpenDeleteModal = () => {
        if (selectedRows.length === 0) {
            setShowSelectErrorModal(true);
        } else {
            setShowDeleteModal(true);
        }
    };

    const handleDelete = () => {
        const updatedRows = tableDetails.filter(
            (row, index) => !selectedRows.includes(index),
        );

        setTableDetails(updatedRows);

        setShowDeleteModal(false);
        setDeleteSuccessModal(true);
        setSelectedRows([]);
        setDeleteRowCount(selectedRows.length);
    };

    const formatAppointMentDate = (dateString) => {
        const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
        const date = new Date(timestamp);

        if (isNaN(date.getTime())) {
            return "";
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${month}/${day}/${year}`;
    };

    function getRecievedChargeClass(recievedCharge) {
        if (recievedCharge === 0) {
            return "nonpaid-claims";
            // } else if (recievedCharge === "") {
            //   return 'paid-claims';
        } else {
            return "";
        }
    }

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const closeFilters = () => {
        setShowFilters(false);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const formatDOSDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };

    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };



    const handleOpenVerifiedModal = (item) => {
        setSelectedVerifiedData("");
        if (item.isVerified) {
            setSavingData(true);
            return;
        }

        setClaimId(item.ClaimId);
        setCptCode(item.CPTOld);
        const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

        setDos(formattedClaimDOS);

        setShowVerifiedSaveModal(true);
        setSavingData(true);
    };

    //Saved all Verified  data
    const handleSaveVerifiedData = () => {
        setSavingData(false);

        setSelectedVerifiedData("");

        var inputStruct = {
            sPracticeID: userPracticeID,
            sClaimID: claimId,
            Comments: selectedVerifiedData,
            DOS: dos,
            CPTCode: cptCode,
            LoggedInUserDetails: userData,
        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        var myInputData = JSON.stringify(myInput);

        const response = fetch(
            APIConstants.BASE_URL + ClaimStatusConstants.SaveVerifiedData,
            {
                method: "POST",

                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInputData,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data.d);

                setSavingData(true);

                const filteredClaims = displayedRecords.filter((claim) => {
                    if (claim.ClaimId == claimId) {
                        claim.isVerified = true;
                    }

                    return true;
                });

                setDisplayedRecords(filteredClaims);
                setShowVerifiedSaveModal(false);
                // handleTableDataClick("",selectedServiceIDs)
            })
            .catch((error) => {
                console.error("An error occurred:", error);
            });
    };

    const verifiedButtonClassName = savingData ? "saving" : "btn-style3 mt-2";

    //Get all table data based on totalStatus Records

    const ReloadClaimsData = (filterType, isTotal, claimDOS) => {
        setLoading(true);
        setDisplayedRecords([]);

        const filteredClaimsData = allClaims.filter((claim) => {
            const curDOS = formatDOSDate(claim["ClaimDOS"]);
            const submitDate = formatSubmitDate(claim.SubmitDate);
            const SecClaimSubmiDate = formatSubmitDate(claim.SecClaimSubmiDate);
            const recvdCharge = claim.recvdCharge;
            if (!isTotal && curDOS === claimDOS) {
                switch (filterType) {
                    case "all":
                        return true;
                    case "submit":
                        return submitDate !== "" || SecClaimSubmiDate !== "";
                    case "nonsubmit":
                        return submitDate === "" && SecClaimSubmiDate === "";
                    case "sent":
                        return claim["ClaimStatusInt"] == 3;
                    case "fwd":
                        return claim["ClaimStatusInt"] == 5;
                    case "paid":
                        return (
                            claim["ClaimStatusInt"] == 1 &&
                            claim["isDenied"] == 0 &&
                            recvdCharge > 0
                        );
                    case "rejected":
                        return claim["ClaimStatusInt"] == 2;
                    case "denied":
                        return claim["isDenied"] == 1;
                    case "recvd":
                        return claim["isPaymentReceived"];
                    case "posted":
                        return claim["isPaymentPosted"];
                    default:
                        return false;
                }
            } else {
                switch (filterType) {
                    case "all":
                        return true;
                    case "submit":
                        return submitDate !== "" || SecClaimSubmiDate !== "";
                    case "nonsubmit":
                        return submitDate === "" && SecClaimSubmiDate === "";
                    case "sent":
                        return claim["ClaimStatusInt"] == 3;
                    case "fwd":
                        return claim["ClaimStatusInt"] == 5;
                    case "paid":
                        return (
                            claim["ClaimStatusInt"] == 1 &&
                            claim["isDenied"] == 0 &&
                            recvdCharge > 0
                        );
                    case "rejected":
                        return claim["ClaimStatusInt"] == 2;
                    case "denied":
                        return claim["isDenied"] == 1;
                    case "recvd":
                        return claim["isPaymentReceived"];
                    case "posted":
                        return claim["isPaymentPosted"];
                    default:
                        return false;
                }
            }
        });

        setTimeout(() => {
            setLoading(false);
            setCategoryFilteredClaims(filteredClaimsData);
            setDisplayedRecords(filteredClaimsData);
        }, 500);
    };

    const handleClaimCountsClick = (rowKey) => {
        setActiveCounts(rowKey);
    };

    useEffect(() => {
        setAllClaims(tableDetails);
        setCategoryFilteredClaims(tableDetails);
        setDisplayedRecords(tableDetails);
    }, [tableDetails]);

    useEffect(() => {
        const toLower = (val) =>
            typeof val === "string"
                ? val.toLowerCase()
                : val?.toString().toLowerCase();

        const matches = (field, searchVal) =>
            searchVal ? toLower(field)?.includes(searchVal.toLowerCase()) : true;

        const matchesStartsWith = (field, searchVal) =>
            searchVal ? toLower(field)?.startsWith(searchVal.toLowerCase()) : true;

        const matchesNumberField = (field, searchVal) => {
            if (searchVal === "") return true;
            if (searchVal === "0") {
                return Number(field) === 0;
            }

            const fieldStr = field != null ? field.toString().toLowerCase() : "";
            return fieldStr.includes(searchVal.toLowerCase());
        };

        const filteredData = categoryFilteredClaims.filter((item) => {
            const dosDate = formatDOSDate(item.ClaimDOS);
            const dobDate = formatDOSDate(item.DOB);
            const submitDate = formatSubmitDate(item.SubmitDate);
            const secSubmitDate = formatSubmitDate(item.SecClaimSubmiDate);
            const paymentChequeDate = formatSubmitDate(item.PaymentChequeDate);
            const secCPTChequeDate = formatSubmitDate(item.SecCPTChequeDate);

            return (
                matches(dosDate, searchByDOS) &&
                matches(item.LocationNickname, searchByLocation) &&
                matches(item.ClaimId, searchByClaim) &&
                matchesStartsWith(item.LastName, searchByPatient) &&
                matches(dobDate, searchByDOB) &&
                matches(item.ClaimConType, searchBySUD) &&
                matches(item.InsCompNickName, searchByInsurance) &&
                matches(item.SecInsCompNickName, searchBySecInsurance) &&
                matches(item.CPTOld, searchByCPT) &&
                matchesNumberField(item.totalcharge, searchByTotalCharge) &&
                matchesNumberField(item.Adjustment, searchByAdjustmentAmt) &&
                matchesNumberField(item.SecPendingAmt, searchBySecPendingAmt) &&
                matches(submitDate, searchBySubmitdate) &&
                matches(secSubmitDate, searchBySecSubmitdate) &&
                matchesNumberField(item.claimbln, searchByBalance) &&
                matches(item.ClearingHouseName, searchByClearingHouse) &&
                matchesNumberField(item.recvdCharge, searchByRcvdCharge) &&
                matchesNumberField(item.SecrecvdCharge, searchBySecRcvdCharge) &&
                matchesNumberField(item.Deductible, searchByDeductible) &&
                matchesNumberField(item.PatientAmount, searchByPatientRes) &&
                matchesNumberField(item.Copay, searchByCopay) &&
                matchesNumberField(item.OtherAdjustment, searchByOtherAdj) &&
                matchesNumberField(item.FederalReduction, searchFederal) &&
                matchesNumberField(item.WriteOffAmount, searchByWriteOffValue) &&
                matchesNumberField(item.AdminwriteOff, searchByAdminWriteOffValue) &&
                matches(item.PaymentChqueNo, searchByCheckNum) &&
                matches(paymentChequeDate, searchByCheckDate) &&
                matches(item.PayerRefNumber, searchByPayerRef) &&
                matches(item.SecCPTChequeNumber, searchBySecCheckNum) &&
                matches(secCPTChequeDate, searchBySecCheckDate) &&
                matches(item.SecPayerclaimRefNumber, searchBySecPayerRef) &&
                matches(item.UpdaterName, searchByUpdatedBy) &&
                matches(item.SubmitterName, searchBySubmittedBy) &&
                matches(item.providername, searchByProvider) &&
                matches(removeHtmlTags(item.ClaimStatusFlag), searchByStatus)
            );
        });

        const hasSearch =
            searchByDOS ||
            searchByPatient ||
            searchByDOB ||
            searchByInsurance ||
            searchByClaim ||
            searchByProvider ||
            searchBySecInsurance ||
            searchByAdjustmentAmt ||
            searchBySecPendingAmt ||
            searchByLocation ||
            searchByCPT ||
            searchByTotalCharge ||
            searchByRcvdCharge ||
            searchByWriteOffValue ||
            searchByAdminWriteOffValue ||
            searchBySubmitdate ||
            searchBySecSubmitdate ||
            searchBySecRcvdCharge ||
            searchBySecCheckNum ||
            searchBySecCheckDate ||
            searchByCopay ||
            searchFederal ||
            searchByOtherAdj ||
            searchBySecPayerRef ||
            searchByDeductible ||
            searchByPatientRes ||
            searchByUpdatedBy ||
            searchBySubmittedBy ||
            searchByBalance ||
            searchByCheckNum ||
            searchByCheckDate ||
            searchByStatus ||
            searchByPayerRef ||
            searchBySUD ||
            searchByClearingHouse;

        setDisplayedRecords(hasSearch ? filteredData : categoryFilteredClaims);
    }, [
        searchByDOS,
        searchByPatient,
        searchByDOB,
        searchByInsurance,
        searchByClaim,
        searchByProvider,
        searchByCPT,
        searchBySecInsurance,
        searchByAdjustmentAmt,
        searchBySecPendingAmt,
        searchByTotalCharge,
        searchByRcvdCharge,
        searchBySecRcvdCharge,
        searchByWriteOffValue,
        searchByAdminWriteOffValue,
        searchByLocation,
        searchBySubmitdate,
        searchBySecSubmitdate,
        searchBySecCheckNum,
        searchBySecCheckDate,
        searchBySecPayerRef,
        searchByDeductible,
        searchByPatientRes,
        searchByUpdatedBy,
        searchBySubmittedBy,
        searchByBalance,
        searchByCheckNum,
        searchByCheckDate,
        searchByStatus,
        searchByPayerRef,
        searchByClearingHouse,
        searchByCopay,
        searchFederal,
        searchByOtherAdj,
        searchBySUD,
        categoryFilteredClaims,
    ]);

    const debounceSecPendingTimeout = useRef(null);

    const SaveSecPendingCharges = async (inputText, item, eventName) => {
        const SecPendingAmt = inputText === "" ? "" : parseFloat(inputText);

        // Clear the previous timeout if it exists
        if (debounceSecPendingTimeout.current) {
            clearTimeout(debounceSecPendingTimeout.current);
        }

        debounceSecPendingTimeout.current = setTimeout(async () => {
            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: inputText,
                DOS: formatDOSDate(item.DOS),
                PriorSec: item.PriorSecClaim,
                UpdatedBy: userData.userID,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(
                        APIConstants.BASE_URL_BILLING +
                        CommonAPIConstants.SaveSecPendingCharges,
                        {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: myInput,
                        },
                    );

                    const data = await response.json();

                    if (response.ok) {
                        const updatedItems = secPendingAmt.map((existingItem) =>
                            existingItem.ClaimId === item.ClaimId
                                ? { ...existingItem, SecPendingAmt: inputText }
                                : existingItem,
                        );

                        item.SecPendingAmt = inputText;

                        // CalculateandShowClaimBalance(item);
                    } else {
                        console.error("API error:", data);
                    }
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }, 500);
    };

    const handleInputChange = (claimId, fieldName, value) => {
        setEditedValues((prev) => ({
            ...prev,
            [claimId]: {
                ...(prev[claimId] || {}),
                [fieldName]: value,
            },
        }));
    };

    const debounceCopayTimeout = useRef(null);

    const SavePatientCopay = async (inputText, item, eventName) => {
        if (debounceCopayTimeout.current) {
            clearTimeout(debounceCopayTimeout.current);
        }

        debounceCopayTimeout.current = setTimeout(async () => {
            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: inputText,
                CopayType: "CASH",
                DOS: formatDOSDate(item.DOS),
                PriorSec: item.PriorSecClaim,
                UpdatedBy: userData.userID,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(
                        APIConstants.BASE_URL_BILLING +
                        ClaimStatusConstants.UpdateCopayData,
                        {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${sAuthToken}`,
                            },
                            body: myInput,
                        },
                    );

                    const data = await response.json();
                    //   console.log("Response" + ClaimStatusConstants.UpdateCopayData, data);

                    if (response.ok) {
                        const updatedItems = copay.map((existingItem) =>
                            existingItem.ClaimId === item.ClaimId
                                ? { ...existingItem, Copay: inputText }
                                : existingItem,
                        );

                        item.Copay = inputText;
                    }
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }, 500);
    };

    const ClosclaimWithCPT = async () => {
        try {
            //   console.log("Selected Write-Off Rows:", selectedWriteOffRows);
            if (!selectedWriteOffRows.length) {
                setShowSelectErrorModal(true);
                return;
            }
            const selectedDataArray = selectedWriteOffRows.map((item) => {
                const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

                return {
                    ClaimID: item?.ClaimId ?? "",
                    PracticeID: userPracticeID ?? "",
                    iIsCompClaim: 0,
                    CPTcode: item?.CPTOld ?? "",
                    DOS: formattedClaimDOS ?? "",
                };
            });
            const inputStruct = {
                JsonDataArr: selectedDataArray,
                LoggedInUserDetails: userData,
            };
            const myInput = JSON.stringify({
                sInputJSON: JSON.stringify(inputStruct),
            });
            const response = await fetch(
                `${APIConstants.BASE_URL}${ClaimStatusConstants.CloseClaimWithCPT}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );
            if (!response.ok) {
                console.error("Error sending data to the API:", response.statusText);
                return;
            }
            const responseData = await response.json();
            const parsedData = responseData?.d
                ? JSON.parse(responseData.d)
                : responseData;

            setUpdatedTableData(parsedData);
            setShowSuccessModal(true);
            setSelectedWriteOffRows([]);
        } catch (error) {
            console.error("An error occurred while closing claims:", error);
        }
    };

    const debounceChequeTimeout = useRef(null);

    // Saved the Claim CPT Cheque Number

    const SaveClaimCPTChequeNumber = (inputText, item, eventName) => {
        const updatedItems = Array.isArray(cptChequeNumber)
            ? cptChequeNumber.map((existingItem) =>
                existingItem === item
                    ? { ...existingItem, PaymentChqueNo: inputText }
                    : existingItem,
            )
            : [];

        setcptChequeNumber(updatedItems);

        item.PaymentChqueNo = inputText;

        // Clear the previous timeout if it exists
        if (debounceChequeTimeout.current) {
            clearTimeout(debounceChequeTimeout.current);
        }

        debounceChequeTimeout.current = setTimeout(async () => {
            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                ChequeNumber: inputText,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 1,
                IsLineItemData: 1,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(
                        APIConstants.BASE_URL_BILLING +
                        PostingpaymentsConstants.UpdateCheckNumber,
                        {
                            method: "POST",

                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },

                            body: myInput,
                        },
                    );

                    const data = await response.json();
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }, 1000);
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };

    const formatDateForAPI = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        const formattedMonth = (month || "").padStart(2, "0");
        const formattedDay = (day || "").padStart(2, "0");
        return `${formattedMonth}/${formattedDay}/${year}`;
    };

    const UpdateClaimChequeDate = (inputText, item) => {
        let updatedCheckDate = inputText;

        if (isValidDate(inputText)) {
            updatedCheckDate = formatDateForAPI(inputText);
            setCheckDate(updatedCheckDate);
        }

        item.PaymentChequeDate = updatedCheckDate;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            ChequeDate: updatedCheckDate,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 1,
            IsLineItemData: 1,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

        const response = fetch(
            APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckDate,
            {
                method: "POST",

                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInput,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const updatedItems = cptChequeDate.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            PaymentChequeDate: updatedCheckDate,
                        }
                        : existingItem,
                );

                setCptChequeDate(updatedItems);
            })
            .catch((error) => {
                console.error("An error occurred:", error);
            });
    };

    const debounceRefTimeout = useRef(null);

    // Saved the Claim CPT PayerRefID
    const SaveClaimsPayerRefID = (inputText, item, eventName) => {
        item.PayerRefNumber = inputText;

        if (debounceRefTimeout.current) {
            clearTimeout(debounceRefTimeout.current);
        }

        debounceRefTimeout.current = setTimeout(async () => {
            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,

                PayerReferenceNumber: inputText,
                PatientID: item.PatientID,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 1,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(
                        APIConstants.BASE_URL_BILLING +
                        PostingpaymentsConstants.UpdateClaimReferencenumber,
                        {
                            method: "POST",

                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },

                            body: myInput,
                        },
                    );

                    const data = await response.json();

                    const updatedItems = claimPayerRefID.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                PayerRefNumber: inputText,
                            }
                            : existingItem,
                    );

                    setClaimPayerRefID(updatedItems);
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }, 1000);
    };

    const debounceSecNumTimeout = useRef(null);

    const SecSaveClaimCPTChequeNumber = (inputText, item, eventName) => {
        item.SecCPTChequeNumber = inputText;

        if (debounceSecNumTimeout.current) {
            clearTimeout(debounceSecNumTimeout.current);
        }

        debounceSecNumTimeout.current = setTimeout(async () => {
            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                ChequeNumber: inputText,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 2,
                IsLineItemData: 1,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

            try {
                if (eventName.type == "blur") {
                    const response = await fetch(
                        APIConstants.BASE_URL_BILLING +
                        PostingpaymentsConstants.UpdateCheckNumber,
                        {
                            method: "POST",

                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },

                            body: myInput,
                        },
                    );

                    const data = await response.json();

                    const updatedItems = cptSecChequeNumber.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                SecCPTChequeNumber: inputText,
                                isDataUpdated: true,
                            }
                            : existingItem,
                    );

                    setcptsecChequeNumber(updatedItems);
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        }, 1000);
    };

    const SecUpdateClaimChequeDate = (inputText, item) => {
        let updatedCheckDate = inputText;

        if (isValidDate(inputText)) {
            updatedCheckDate = formatDateForAPI(inputText);
            setCptSecChequeDate(updatedCheckDate);
        }

        item.SecCPTChequeDate = updatedCheckDate;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            ChequeDate: updatedCheckDate,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 2,
            IsLineItemData: 1,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

        const response = fetch(
            APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateCheckDate,
            {
                method: "POST",

                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInput,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const updatedItems = cptSecChequeDate.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            PaymentChequeDate: updatedCheckDate,
                        }
                        : existingItem,
                );

                setCptSecChequeDate(updatedItems);
            })
            .catch((error) => {
                console.error("An error occurred:", error);
            });
    };

    // Saved the Secondary Claim CPT PayerRefID
    const SecSaveClaimsPayerRefID = (inputText, item) => {
        item.SecPayerclaimRefNumber = inputText;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,

            PayerReferenceNumber: inputText,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 2,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

        const response = fetch(
            APIConstants.BASE_URL_BILLING +
            PostingpaymentsConstants.UpdateClaimReferencenumber,
            {
                method: "POST",

                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInput,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                const updatedItems = secClaimPayerRefID.map((existingItem) =>
                    existingItem === item
                        ? {
                            ...existingItem,
                            SecPayerclaimRefNumber: inputText,
                        }
                        : existingItem,
                );

                setSecClaimPayerRefID(updatedItems);
            })
            .catch((error) => {
                console.error("An error occurred:", error);
            });
    };

    //saved the notes message

    const UpdateClaimNotes = (inputText, item) => {
        item.ClaimNotes = inputText;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            ClaimNotes: inputText,
            FirstName: item.FirstName,
            LastName: item.LastName,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

        const response = fetch(
            APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimNotes,
            {
                method: "POST",

                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

                body: myInput,
            },
        )
            .then((response) => response.json())
            .then((data) => {
                setClaimNotes((prevClaimNotes) =>
                    prevClaimNotes.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                ClaimNotes: inputText,
                            }
                            : existingItem,
                    ),
                );
            })
            .catch((error) => {
                console.error("An error occurred:", error);
            });
    };

    //Check Eligiblity

    const handleCheckeligibility = async (e, rowIndex) => {
        if (selectedPolicyRows.length == 0) {
            setShowSelectErrorModal(true);
            return;
        }

        setRowState((prevState) => ({
            ...prevState,
            [claimID]: { isLoading: true, isHidden: true, showIcon: true },
        }));

        const selectedDataArray = [];

        for (const rowIndex of selectedPolicyRows) {
            const item =
                filteredTableDetails[rowIndex] || filteredTableDetails[rowIndex];
            setClaimID(item.ClaimId);
            setShowSelectErrorModal(false);

            setIsLoading(true);

            const eligibilityDOS = formatDOSDate(item.ClaimDOS);

            var InsCountryId = item.PrimaryIns;
            if (InsCountryId == null) {
                InsCountryId = "";
            }

            var PayerID = item.InsPayerID;
            if (PayerID == null) {
                PayerID = "";
            }

            var inputStruct = {
                PatientID: item.PatientID,
                PracticeID: userPracticeID,
                PolicyNumber: item.PolicyNumber + "",
                DOS: eligibilityDOS,
                RowIndex: rowIndex,
            };
        }

        var objPatientDetails = {
            objPatientDetails: inputStruct,
        };
        var myInput = JSON.stringify(objPatientDetails);

        var myInput = JSON.stringify(objPatientDetails);
        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })

            .then((data) => {
                const responseData = data;
                const parsedData = JSON.parse(responseData);

                setRowState((prevState) => ({
                    ...prevState,
                    [claimID]: { isLoading: false, isHidden: false, showIcon: true },
                }));

                setCheckEligibility(parsedData);
                var RowIndex = parsedData.RowIndex;
                var InsStatus = parsedData.InsStatus;
                setIsInStatus(parsedData.InsStatus);
                var EligibilityError = parsedData.EligibilityError;

                const payerIDElement = document.querySelector(`.payer${RowIndex}`);

                const filteredClaims = filteredTableDetails.filter((item) => {
                    if (item.ClaimId == claimID) {
                        if (payerIDElement) {
                            if (parsedData.InsStatus === "Active") {
                                payerIDElement.style.color = "green";
                            } else {
                                payerIDElement.style.color = "red";
                            }
                        }
                    }

                    return true;
                });

                setFilteredTableDetails(filteredClaims);
            })
            .catch((error) => {
                console.error("An error occurred:", error);

                setRowState((prevState) => ({
                    ...prevState,
                    [claimID]: { isLoading: false, isHidden: false, showIcon: true },
                }));
            });
    };

    const handleSecCheckeligibility = async (e, rowIndex) => {
        try {
            const selectedDataArray = [];

            for (const rowIndex of selectedSecInsuranceRows) {
                const item = displayedRecords[rowIndex] || displayedRecords[rowIndex];

                // setIsLoading(true);

                const eligibilityDOS = formatDOSDate(item.ClaimDOS);

                var InsCountryId = item.PrimaryInsurance;
                if (InsCountryId == null) {
                    InsCountryId = "";
                }

                var PayerID = item.SecPayerID;
                if (PayerID == null) {
                    PayerID = "";
                }

                var inputStruct = {
                    PayerID: PayerID + "",
                    sIns_PolicyNumber: item.PolicyNumber + "",
                    patientID: item.PatientId,
                    sInsuredFName: item.FirstName,
                    sInsuredLName: item.LastName,
                    sInsuredStateName: item.InsuredStateName + "",
                    sInsuredDOB: formatDOSDate(item.DOB) + "",
                    sInsCoID: InsCountryId,
                    EligibilityDOS: eligibilityDOS + "",
                    EligibilityRowIndex: rowIndex,
                    LoggedInUserDetails: userData,
                };
            }
            var myInput = { sInputJSON: JSON.stringify(inputStruct) };

            myInput = JSON.stringify(myInput);

            try {
                const response = await fetch(
                    APIConstants.BASE_URL + CommonAPIConstants.CheckPatientEligibility,
                    {
                        method: "POST",

                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },

                        body: myInput,
                    },
                );

                if (response.ok) {
                    const responseData = await response.json();

                    const parsedData = JSON.parse(responseData.d);

                    setCheckEligibility(parsedData);

                    if (checkEligibility.length > 0) {
                        var RowIndex = checkEligibility[0].RowIndex;
                        var InsStatus = checkEligibility[0].InsStatus;
                        setIsInStatus(InsStatus);
                        var EligibilityError = checkEligibility[0].EligibilityError;
                    }

                    const payerIDElement = document.querySelector(
                        `.payer-id-${RowIndex}`,
                    );

                    if (payerIDElement) {
                        if (InsStatus === "Active") {
                            payerIDElement.style.color = "green";
                        } else {
                            payerIDElement.style.color = "red";
                        }
                    }
                } else {
                    setCheckEligibility([]);
                    console.error("Error sending data to the API");
                }
            } catch (error) {
                console.error("An error occurred:", error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputClick = () => {
        setIsFocused(true);
    };

    const handleRowClick = (index) => {
        setActiveRow(index);
    };

    const getVerifiedBy = (name) => {
        if (!name) {
            return ""; // Return an empty string if 'name' is undefined
        }

        return name
            .split(" ")
            .map((word) => (word[0] ? word[0].toUpperCase() : ""))
            .join("");
    };

    const handleClaimCheckboxChange = () => {
        setIsClaimChecked(!isClaimChecked);
    };

    //Filtered the data based on Status in MainTable

    const handleStatusFilterChange = (statusInt) => {
        setStatusFilter(statusInt);

        const filteredRecords = tableDetails.filter((item) => {
            const cleanClaimStatusFlag = removeHtmlTags(item.ClaimStatusFlag);
            switch (statusInt) {
                case 0:
                    return cleanClaimStatusFlag === "N";
                case 1:
                    return cleanClaimStatusFlag === "P";
                case 2:
                    return cleanClaimStatusFlag === "R";
                case 5:
                    return cleanClaimStatusFlag === "F";
                case 9:
                    return cleanClaimStatusFlag === "D";

                case 10:
                    return cleanClaimStatusFlag === "P0";
                case 11:
                    return cleanClaimStatusFlag === "S0";
                default:
                    return false;
            }
        });

        setDisplayedRecords(filteredRecords);
    };

    //   const isActive = (status) => {
    //     return prevFilter === status;
    //   };

    const handleClosedCheckboxChange = () => {
        setIsClaimClosed((prevState) => !prevState);
    };

    const tableCountRef = useRef("");

    const handleCountPrint = () => {
        if (tableCountRef.current) {
            const tableHTML = tableCountRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Claim Status</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #0173b7;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A4 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
        } else {
            console.error("Table reference is not set.");
        }
    };

    const exportToCountExcel = () => {
  const excelData = [
    {
      "Type": "Total",
      "All CPT Lines": totalsClaims.allClaims,
      "Submitted": totalsClaims.totalSubmitClaim,
      "Non-submitted": totalsClaims.totalNonSubmitted,
      "SENT": totalsClaims.totalSent,
      "FORWARDED": totalsClaims.totalForwarded,
      "RECEIVED": totalsClaims.totalReceivedClaim,
      "POSTED": totalsClaims.totalPosted,
      "PAID": totalsClaims.totalPaid,
      "REJECTED": totalsClaims.totalRejected,
      "DENIED": totalsClaims.totalDenied
    }
  ];
  exportExcel(excelData, "ClaimStatus", "ClaimStatus");
};

    const exportToCountPDF = () => {
        const pagename = "ClaimStatus";
        const table = tableCountRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : "";

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: InputJSON,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data && data[2]) {
                    const url = data[2];
                    window.open(url, "_blank");
                }
            })
            .catch((error) => {
                console.error("Export to PDF failed", error);
            });
    };

    const tableRef = useRef("");

  const handlePrint = () => {
    const selectedColumns = printColumnsConfig.filter(
      (col) => printColumnVisibility[col.key]
    );
    if (selectedColumns.length === 0) {
      alert("Please select at least one column to print.");
      return;
    }
    const columnCount = selectedColumns.length;
    let bodyFontSize = 16;
    let cellFontSize = 15;
    let headerFontSize = 16;
    let titleFontSize = 26;
    if (columnCount > 15 && columnCount <= 25) {
      bodyFontSize = 14;
      cellFontSize = 13;
      headerFontSize = 14;
      titleFontSize = 24;
    }
    if (columnCount > 25) {
      bodyFontSize = 12;
      cellFontSize = 11;
      headerFontSize = 12;
      titleFontSize = 22;
    }
    const prevVisibleCount = visibleRecords;
    setVisibleRecords(filteredTableDetails.length);
    setTimeout(() => {
      const rowsHTML = displayedRecords
        .filter((item) => item.IsCPTMoved != 1)
        .map((item, index) => {
          const cells = selectedColumns
      .map((col) => `<td>${col.render(item, index) ?? ""}</td>`)
      .join("");

          return `<tr>${cells}</tr>`;
        })
        .join("");
const totalsRow = `
<tr style="background-color:lightgray;font-weight:bold">

${selectedColumns
  .map((col, index) => {
    switch (col.key) {
      case "Units":
        return `<td>${totals.totalUnits}</td>`;
      case "TotalCharge":
        return `<td>$${totals.totalSubmitted.toFixed(2)}</td>`;
      case "RecvdPri":
        return `<td>$${totals.totalReceived.toFixed(2)}</td>`;
      case "RecvdSec":
        return `<td>$${totals.totalSecReceived.toFixed(2)}</td>`;
      case "Adjustment":
        return `<td>$${totals.totalAdjustmentAmt.toFixed(2)}</td>`;
      case "SecPendingAmt":
        return `<td>$${totals.totalSecPendingAmt.toFixed(2)}</td>`;
      case "Deductible":
        return `<td>$${totals.totalDeductible.toFixed(2)}</td>`;
      case "PatientAmount":
        return `<td>$${totals.totalPatientRes.toFixed(2)}</td>`;
      case "Copay":
        return `<td>$${totals.totalCopay.toFixed(2)}</td>`;
      case "OtherAdjustment":
        return `<td>$${totals.totalOtherAdjustment.toFixed(2)}</td>`;
      case "FederalPayment":
        return `<td>$${totals.totalFederalReduction.toFixed(2)}</td>`;
      case "WriteOffAmount":
        return `<td>$${totals.totalWriteOff.toFixed(2)}</td>`;
      case "AdminWriteOff":
        return `<td>$${totals.totalAdminWriteOff.toFixed(2)}</td>`;
      case "Balance":
        return `<td>$${totals.totalBalance.toFixed(2)}</td>`;
      default:
        return `<td></td>`;
    }
  })
  .join("")}
</tr>
`;
      const headerHTML = selectedColumns
        .map((col) => `<th>${col.label}</th>`)
        .join("");

            const printWindow = window.open("", "_blank");

            printWindow.document.write(`
      <html>
        <head>
          <title>Claim Status</title>
         <style>
  body {
    font-family: Arial, sans-serif;
    margin: 20px;
    font-size: ${bodyFontSize}px;
    color: #000;
  }
  .print-title {
    text-align: center;
    font-size: ${titleFontSize}px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #0173b7;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid #000;
    padding: 6px;
    text-align: left;
    font-size: ${cellFontSize}px;
    word-break: break-word;
  }
  th {
    background-color: #e5e7eb;
    color: #000;
    font-weight: 600;
    font-size: ${headerFontSize}px;
  }
  @media print {
    @page {
      size: A3 landscape;
      margin: 10mm;
    }
  }

  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
</style>
        </head>
        <body>
          <table>
            <thead>
              <tr>${headerHTML}</tr>
            </thead>
            <tbody>
              ${rowsHTML}
            ${totalsRow}
            </tbody>
          </table>
          <script>
            window.onload = function() {
              window.print();
            };
            window.onafterprint = function() {
              window.close();
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
    setTimeout(() => {
      setVisibleRecords(prevVisibleCount);
    }, 50);
  }, 50);
};
 const exportToExcel = () => {
  const rows = displayedRecords
    .slice(0, tableDetails.length)
    .filter(item => item.IsCPTMoved !== 1);
  const printableRows = rows.map((item, i) => {
    const rowObj = {};
    printColumnsConfig.forEach(col => {
      rowObj[col.label] =
        col.key === "index"
          ? col.render(item, i)
          : col.render
            ? col.render(item)
            : item[col.key] || "";
    });
    return rowObj;
  });
const totalsRow = {};
  printColumnsConfig.forEach(col => {
    switch (col.key) {
      case "Units":
        totalsRow[col.label] = totals.totalUnits;
        break;
      case "TotalCharge":
        totalsRow[col.label] = totals.totalSubmitted.toFixed(2);
        break;
      case "RecvdPri":
        totalsRow[col.label] = totals.totalReceived.toFixed(2);
        break;
      case "RecvdSec":
        totalsRow[col.label] = totals.totalSecReceived.toFixed(2);
        break;
      case "Adjustment":
        totalsRow[col.label] = totals.totalAdjustmentAmt.toFixed(2);
        break;
      case "SecPendingAmt":
        totalsRow[col.label] = totals.totalSecPendingAmt.toFixed(2);
        break;
      case "Deductible":
        totalsRow[col.label] = totals.totalDeductible.toFixed(2);
        break;
      case "PatientAmount":
        totalsRow[col.label] = totals.totalPatientRes.toFixed(2);
        break;
      case "Copay":
        totalsRow[col.label] = totals.totalCopay.toFixed(2);
        break;
      case "OtherAdjustment":
        totalsRow[col.label] = totals.totalOtherAdjustment.toFixed(2);
        break;
      case "FederalPayment":
        totalsRow[col.label] = totals.totalFederalReduction.toFixed(2);
        break;
      case "WriteOffAmount":
        totalsRow[col.label] = totals.totalWriteOff.toFixed(2);
        break;
      case "AdminWriteOff":
        totalsRow[col.label] = totals.totalAdminWriteOff.toFixed(2);
        break;
      case "Balance":
        totalsRow[col.label] = totals.totalBalance.toFixed(2);
        break;
      default:
        totalsRow[col.label] = "";
    }
  });
  printableRows.push(totalsRow);
  exportExcel(printableRows, "ClaimStatus", "ClaimStatus");
};

    const exportToPDF = () => {
        const pagename = "ClaimStatus";
        const table = tableContainerRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : "";

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);

        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: InputJSON,
        })
            .then((response) => response.json()) // Parse the response as JSON
            .then((data) => {
                if (data && data[2]) {
                    const url = data[2];
                    window.open(url, "_blank");
                }
            })
            .catch((error) => {
                console.error("Export to PDF failed", error);
            });
    };

    const fetchGetAllEvents = (item) => {
        setselectedClaimID(item.ClaimId);

        var inputJSON = {
            PracticeID: userPracticeID,
            ModuleName: "Billing",
            dtFromDate: startDate,
            dtToDate: endDate,
            DataID: item.ClaimId,
            UserID: 0,
            DateType: "DOS",
        };

        var sInputJSON = JSON.stringify(inputJSON);

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetClaimAllEvents}?sJSONInput=${sInputJSON}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data;

                setEventData(patientData);

                setShowFaxModal(true);
            })
            .catch((error) => {
                console.error("Error fetching patient names:", error);
            });
    };

    const GetPDFCMS = (item) => {
        const claimFilters = {
            PracticeID: userPracticeID,
            ClaimID: item.ClaimId,
            PatientID: item.PatientID,
        };

        const sInputJSON = JSON.stringify(claimFilters);
        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetPDFCMS1500}?sInputJSON=${sInputJSON}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json()) // Parse the response as JSON
            .then((data) => {
                if (data && data) {
                    const parsedData = JSON.parse(data);
                    const url = parsedData.DocumentURL;
                    window.open(url, "_blank");
                }
            })
            .catch((error) => {
                console.error(" PDF failed", error);
            });
    };

    const handleRegeneratePDFCMS = (item) => {
        const { ClaimId } = item;

        setRowState((prevState) => ({
            ...prevState,
            [ClaimId]: { isLoading: true, isHidden: false },
        }));

        const objInput = {
            PatientID: item.PatientID,
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PriorSecClaim: item.PriorSecClaim,
            UserTimeZoneOffSet: 300,
            UserID: userId,
        };

        const sInputJSON = JSON.stringify({ objClaim: objInput });

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.SaveRegeneratePDFCMS1500}?sInputJSON=${sInputJSON}`;

        // console.log("URL: ", url);

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setReGenerateData(data);

                setRowState((prevState) => ({
                    ...prevState,
                    [ClaimId]: { isLoading: false, isHidden: true },
                }));
            })
            .catch((error) => {
                console.error("An error occurred:", error);

                // In case of error, stop the loading but keep the icon visible for retry
                setRowState((prevState) => ({
                    ...prevState,
                    [ClaimId]: { isLoading: false, isHidden: false },
                }));
            });
    };

    const GetProviderPDF = (item) => {
        const claimFilters = {
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            CPT: item.CPTOld,
        };

        const sInputJSON = JSON.stringify({ objPatDetails: claimFilters });

        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CPTDcoument}?sInputJSON=${sInputJSON}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json()) // Parse the response as JSON
            .then((data) => {
                //if (data.status==200)
                {
                    const url = JSON.parse(data);
                    window.open(url.DocumentURL, "_blank");
                }
            })
            .catch((error) => {
                console.error(" PDF failed", error);
            });
    };

    const handleGetClaimSubmitHx = (item) => {
        const claimHx = item.ClaimHx;
        const [prefix, suffix] = claimHx ? claimHx.split("$") : [];

        const Patname = `${item.LastName},${item.FirstName}`;
        setselectedPatname(Patname);
        setselectedDOB(formatDOSDate(item.DOB));

        const objClaim = {
            iPracticeID: userPracticeID,
            sClaimID: item.ClaimId,
            ClaimHxIndicator: suffix,
            ClaimPriOrSec: item.PriorSecClaim,
        };

        var sInputJSON = JSON.stringify(objClaim);

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetClaimSubmitHx}?sInputJSON=${sInputJSON}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                if (data) {
                    setShowDataModal(true);
                }
            })
            .catch((error) => {
                console.error("Error fetching patient names:", error);
            });
    };

    const handleApplyCopayData = (item) => {
        var inputStruct = {
            ClaimID: item.ClaimId,
            PostingCharges: item.CopayAmount,
            PracticeID: userPracticeID,
            CPT: item.CPTOld,
            DOS: formatDOSDate(item.ClaimDOS),
            PatientID: item.PatientID,
            UpdatedBy: userData.userID,
            CopayType: "Cash",
        };

        var myInputData = JSON.stringify(JSON.stringify({ objClaim: inputStruct }));

        const response = fetch(
            APIConstants.BASE_URL_BILLING + CommonAPIConstants.ApplyCopay,
            {
                method: "POST",

                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sAuthToken}`,
                },

                body: myInputData,
            },
        )
            .then((response) =>
                response.json().then((data) => ({ ok: response.ok, data })),
            )
            .then(({ ok, data }) => {
                if (ok) {
                    const updatedClaims = filteredTableDetails.map((claim) => {
                        if (claim.ClaimId == item.ClaimId) {
                            return {
                                ...claim,
                                CopayAppliedClaim: item.ClaimId,
                                CopayApliedByShortName: item.CopayApliedByShortName,
                                CopayApliedOn: item.CopayApliedOn,
                            };
                        }
                        return claim;
                    });

                    setFilteredTableDetails(updatedClaims);
                    const successMsg = `Copay amount ${item.CopayAmount} applied to claim ${item.ClaimId}`;
                    setErrorMessage(successMsg);
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error);
            });
    };

    const handleDosLinkClick = (item) => {
        const claimId = item.ClaimId;

        localStorage.setItem("selectedClaimItem", JSON.stringify(item));

        const url = `/#/transactionlogs/${claimId}`;
        window.open(url, "_blank");
    };

    const handleLinkClick = (item) => {
        const url = `/#/new-encounter/${item.ClaimId}`;
        window.open(url, "_blank");
    };

    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

        localStorage.setItem("statusPatientID", item.PatientID);

        window.open(url, "_blank");
    };

    useEffect(() => {
        const filteredData = claimFilterRecCountsTableData.filter((item) =>
            item.DOS && typeof item.DOS === "string"
                ? item.DOS.toLowerCase().includes(searchByClaimDos.toLowerCase())
                : true,
        );

        setClaimRecCountsTableData(
            searchByClaimDos ? filteredData : claimFilterRecCountsTableData,
        );

        if (searchByClaimDos && filteredData.length > 0) {
            setShowDetails(true);
        } else {
            setShowDetails(false);
        }
    }, [searchByClaimDos, claimFilterRecCountsTableData]);

    const getRepeatedClaimIdsWithColors = (records) => {
        const claimIdCount = {};
        const claimIdColors = {};
        let toggleColor = true;

        records.forEach((item, index) => {
            if (claimIdCount[item?.ClaimId]) {
                claimIdCount[item?.ClaimId] += 1;
            } else {
                claimIdCount[item?.ClaimId] = 1;

                // Assign alternating colors to repeated ClaimId groups
                claimIdColors[item?.ClaimId] = toggleColor ? "lightgrey" : "gray";
                toggleColor = !toggleColor;
            }
        });

        return { claimIdCount, claimIdColors };
    };

    const { claimIdCount, claimIdColors } =
        getRepeatedClaimIdsWithColors(displayedRecords);

    const handleSort = (key, accessor) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }

        const sortedData = [...displayedRecords].sort((a, b) => {
            let aValue = accessor ? accessor(a) : a[key];
            let bValue = accessor ? accessor(b) : b[key];

            if (aValue == null) aValue = 0;
            if (bValue == null) bValue = 0;

            if (
                key.toLowerCase().includes("date") ||
                key.toLowerCase().includes("dob") ||
                key.toLowerCase().includes("dos")
            ) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            } else if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = parseFloat(aValue) || 0;
                bValue = parseFloat(bValue) || 0;
            } else if (typeof aValue === "string") {
                aValue = aValue.toUpperCase();
                bValue = typeof bValue === "string" ? bValue.toUpperCase() : "";
            }

            if (aValue < bValue) return direction === "asc" ? -1 : 1;
            if (aValue > bValue) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setDisplayedRecords(sortedData);
    };

    // 💰 Save Primary Received Charges
    const saveRecvdCharges = async (inputValue, item) => {
        const recvdCharges = parseFloat(inputValue) || 0;
        if (isNaN(recvdCharges)) return;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            PostingCharges: recvdCharges,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            PriorSec: 1,
        };

        const myInputData = JSON.stringify(JSON.stringify({ objClaim }));

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.CPTReceviedCharge,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInputData,
                },
            );

            const data = await response.json();

            if (response.ok) {
                item.recvdCharge = recvdCharges;

                // Recalculate dependent values
                calculateAdjustment(item);
                calculateBalance(item);

                // Update UI
                setDisplayedRecords((prev) =>
                    prev.map((record) =>
                        record.ClaimId === item.ClaimId
                            ? {
                                ...record,
                                recvdCharge: recvdCharges,
                                // Adjustment: newAdjustment,
                                // claimbln: newBalance,
                            }
                            : record,
                    ),
                );
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("Error saving charges:", error);
        }
    };

    // 🧾 Calculate Adjustment (and sync to DB)
    const calculateAdjustment = (item) => {
        const total = parseFloat(item.totalcharge) || 0;
        const recvd = parseFloat(item.recvdCharge) || 0;
        const secRecvd = parseFloat(item.SecrecvdCharge) || 0;
        const writeoff = parseFloat(item.WriteOffAmount) || 0;
        const ded = parseFloat(item.Deductible) || 0;
        const patient = parseFloat(item.PatientAmount) || 0;
        const federal = parseFloat(item.FederalPayment) || 0;
        const adjustment =
            total - (recvd + secRecvd + ded + patient + writeoff + federal);
        item.Adjustment = adjustment;
        // console.log("=== Adjustment Debug Info ===");
        // console.log({
        //   totalCharge: total,
        //   recvdCharge: recvd,
        //   secRecvd: total,
        //   writeOff: writeoff,
        //   deduct: ded,
        //   patient: patient,
        //   federal: federal,
        //   //   adjustment:adjustment
        // });
        // console.log("==============================".adjustment);
        saveAdjustmentCharges(adjustment, item);
        return adjustment;
    };

    const calculateBalance = (item) => {
        const total = parseFloat(item.totalcharge) || 0;
        const recvd = parseFloat(item.recvdCharge) || 0;
        const secRecvd = parseFloat(item.SecrecvdCharge) || 0;
        const writeoff = parseFloat(item.WriteOffAmount) || 0;
        const ded = parseFloat(item.Deductible) || 0;
        const patient = parseFloat(item.PatientAmount) || 0;
        const adj = parseFloat(item.Adjustment) || 0;
        const otherAdj = parseFloat(item.OtherAdjustment) || 0;
        const federal = parseFloat(item.FederalReduction) || 0;
        const adminwriteoff = parseFloat(item.AdminWriteOff) || 0;
        const copay = parseFloat(item.Copay);

        const balance =
            total -
            (recvd +
                secRecvd +
                adj +
                otherAdj +
                writeoff +
                adminwriteoff +
                copay +
                federal);
        item.claimbln = balance.toFixed(2);
        // console.log("=== Calculating Claim Balance ===");
        // console.log({
        //   totalCharge: total,
        //   recvdCharge: recvd,
        //   secRecvd: secRecvd, // if secRecvd is same as total, keep as total
        //   writeOff: writeoff,
        //   deduct: ded,
        //   adjustment: adj,
        //   OtherAdjustment: otherAdj,
        //   federal: federal,
        //   adminwriteoff: adminwriteoff,
        //   copay: copay,
        //   //   balance:balance
        // });
        // console.log("=================================", balance);
        setDisplayedRecords((prev) =>
            prev.map((record) =>
                record.ClaimId === item.ClaimId
                    ? {
                        ...record,
                        claimbln: balance?.toFixed(2),
                    }
                    : record,
            ),
        );
    };

    // 🧾 Save Adjustment (called both standalone & internally)
    const saveAdjustmentCharges = async (adjustmentValue, item) => {
        setLoading(true);
        try {
            const AdjustAmt = parseFloat(adjustmentValue) || 0;

            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: AdjustAmt,
                DOS: formatDOSDate(item.DOS || item.ClaimDOS),
                PriorSec: item.PriorSecClaim,
                UpdatedBy: userData.userID,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim }));

            const res = await fetch(
                APIConstants.BASE_URL_BILLING +
                CommonAPIConstants.SaveAdjustmentCharges,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );
            if (res) {
                setDisplayedRecords((prev) =>
                    prev.map((record) =>
                        record.ClaimId === item.ClaimId
                            ? {
                                ...record,
                                // recvdCharge: recvdCharges,
                                Adjustment: AdjustAmt,
                                // claimbln: newBalance,
                            }
                            : record,
                    ),
                );
            }
        } catch (error) {
            console.error("An error occurred while saving adjustment:", error);
        } finally {
            setLoading(false);
        }
    };

    // 💸 Save Secondary Received Charges
    const saveSecClaimRecvdCharges = async (inputValue, item) => {
        try {
            const SecrecvdCharges = parseFloat(inputValue) || 0;

            // if (inputValue !== "") return

            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: SecrecvdCharges,
                DOS: formatDOSDate(item.ClaimDOS),
                UpdatedBy: userData.userID,
                PriorSec: 2,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim }));

            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.CPTReceviedCharge,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );

            const data = await response.json();
            //   console.log("outside", response);

            if (response) {
                // console.log("under es");

                item.SecrecvdCharge = SecrecvdCharges;

                // Recalculate & sync with DB
                saveRecvdCharges(item.recvdCharge, {
                    ...item,
                    SecrecvdCharge: SecrecvdCharges,
                    // PatientAmount: 0,
                });
                calculateAdjustment({
                    ...item,
                    SecrecvdCharge: SecrecvdCharges,
                });
                calculateBalance({
                    ...item,
                    SecrecvdCharge: SecrecvdCharges,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred while saving secondary charges:", error);
        }
    };

    const saveClaimDeductible = async (inputValue, item) => {
        try {
            const deductible = parseFloat(inputValue) || 0;

            // if (inputValue !== "") return

            const objClaim = {
                ClaimID: item.ClaimId,
                PracticeID: userPracticeID,
                PatientID: item.PatientID,
                CPT: item.CPTOld,
                PostingCharges: deductible,
                DOS: formatDOSDate(item.DOS),
                UpdatedBy: userData.userID,
            };

            const myInput = JSON.stringify(JSON.stringify({ objClaim: objClaim }));

            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.UpdateClaimDeductible,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );

            const data = await response.json();

            if (response.ok) {
                item.Deductible = deductible;
                calculateAdjustment({
                    ...item,
                    Deductible: deductible,
                });
                calculateBalance({
                    ...item,
                    Deductible: deductible,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred while saving deductible:", error);
        }
    };
    const savePatRes = async (inputValue, item) => {
        const patientAmount = parseFloat(inputValue) || 0;

        // if (inputValue !== "") item.PatientAmount = 0;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            PostingCharges: patientAmount,
            DOS: formatDOSDate(item.DOS || item.ClaimDOS),
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.UpdateClaimPatientResponsibility,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );

            const data = await response.json();

            if (response.ok) {
                item.PatientAmount = patientAmount;
                calculateAdjustment({
                    ...item,
                    PatientAmount: patientAmount,
                });
                calculateBalance({
                    ...item,
                    PatientAmount: patientAmount,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred while saving deductible:", error);
        }
    };



    const saveClaimWriteOff = async (inputValue, item) => {
        const writeOffAmount = parseFloat(inputValue) || 0;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            CPT: item.CPTOld,
            PostingCharges: writeOffAmount,
            DOS: formatDOSDate(item.DOS || item.ClaimDOS),
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateWriteoff,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );

            const data = await response.json();

            if (response.ok) {
                item.WriteOffAmount = writeOffAmount;
                calculateAdjustment({
                    ...item,
                    WriteOffAmount: writeOffAmount,
                });
                calculateBalance({
                    ...item,
                    WriteOffAmount: writeOffAmount,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred while saving write off:", error);
        }
    };


    const handleAdminWriteOffChange = (value, index) => {

        setAdminWriteOffValues(prev => ({
            ...prev,
            [index]: value
        }));
    };



    useEffect(() => {
        if (tableDetails?.length) {
            const initialValues = {};

            tableDetails.forEach((item, index) => {
                if (item.AdminWriteOff) {
                    initialValues[index] = item.AdminWriteOff;
                }
            });

            setAdminWriteOffValues(initialValues);
        }
    }, [tableDetails]);


    const saveAdminClaimWriteOff = async () => {
        let selectedData;

        const selectedDataArray = [];

        const updatedRecords = [...displayedRecords];

        for (const rowIndex of selectedAdminWriteRows) {
            const item = updatedRecords[rowIndex];

            item.AdminWriteOff = item.totalcharge;
            const formattedClaimDOS = formatDOSDate(item.ClaimDOS);
            const writeOffAmount = parseFloat(adminWriteOffValues[rowIndex]) || 0;

            selectedData = {
                ClaimID: item.ClaimId,
                PostingCharges: writeOffAmount,
                PracticeID: userPracticeID,
                CPT: item.CPTOld,
                DOS: formattedClaimDOS,
                UpdatedBy: userData.userID,
                TransactionCode: selectedTransactionCode
            };

            selectedDataArray.push(selectedData);
        }
        const myInput = JSON.stringify(JSON.stringify({ objClaims: selectedDataArray }));

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges,
                {
                    method: "POST",

                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },

                    body: myInput,
                },
            );

            if (response.ok) {
                const responseData = await response.json();

                setUpdatedTableData(responseData);

                setShowConfirmSaveModal(false);
                handleTableDataClick("", selectedServiceIDs)
            } else {
                console.error("Error sending data to the API");
                setSavedRowCount(savedRowCount + selectedRows.length);
            }

            setSelectedRows([]);
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };





    const getClaimAdjustment = (claimId) => {
        if (!adjustmentCodeData || adjustmentCodeData.length === 0) return null;

        const adj = adjustmentCodeData.find(
            (a) => String(a.ClaimID) === String(claimId),
        );

        if (!adj) return null;

        return (
            <label title={adj.ReasonDescription}>{adj.ClaimAdjustmentCode}</label>
        );
    };

    const SaveOtherAdjustment = async (inputValue, item) => {
        const OtherAdjustment = parseFloat(inputValue) || 0;

        const objClaim = {
            ClaimID: item.ClaimId,
            PostingCharges: OtherAdjustment,
            PracticeID: userPracticeID,
            CPT: item.CPTOld,
            DOS: formatDOSDate(item.DOS || item.ClaimDOS),
            PatientID: item.PatientID,
            PriorSec: 1,
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.savOtherAdjustment,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );

            const data = await response.json();

            if (response.ok) {
                item.OtherAdjustment = OtherAdjustment;
                calculateAdjustment({
                    ...item,
                    OtherAdjustment: OtherAdjustment,
                });
                calculateBalance({
                    ...item,
                    OtherAdjustment: OtherAdjustment,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    const SaveFederalReduction = async (inputValue, item) => {
        const federalReduction = parseFloat(inputValue) || 0;

        const objClaim = {
            ClaimID: item.ClaimId,
            PostingCharges: federalReduction,
            PracticeID: userPracticeID,
            CPT: item.CPTOld,
            DOS: formatDOSDate(item.DOS || item.ClaimDOS),
            PatientID: item.PatientID,
            PriorSec: 1,
            UpdatedBy: userData.userID,
        };

        const myInput = JSON.stringify(JSON.stringify({ objClaim }));
        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING +
                PostingpaymentsConstants.SaveFedReduction,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: myInput,
                },
            );

            const data = await response.json();

            if (response.ok) {
                item.FederalReduction = federalReduction;
                calculateAdjustment({
                    ...item,
                    FederalReduction: federalReduction,
                });
                calculateBalance({
                    ...item,
                    FederalReduction: federalReduction,
                });
            } else {
                console.error("API error:", data);
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    };

    const handleGetClaimAttachments = async (item) => {
        setattachmentClaimID(item.ClaimId);
        var objInput = {
            ClaimID: item.ClaimId,
            PracticeID: userData.practiceID,
        };

        var sInputJSON = JSON.stringify(objInput);

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetClaimAttachments}?sInputJSON=${sInputJSON}`;

        // console.log("URL: ", url);

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    //   console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                // console.log("Response Attachment", data);

                setAttachmentData(data);
                setShowAttachmentData(true);
            })
            .catch((error) => {
                console.error("Error fetching:", error);
            });
    };

    const GetDOCPDF = (doc) => {
        window.open(doc, "_blank");
    };
    const allSelected = printColumnsConfig.every(
        (col) => printColumnVisibility[col.key]
    );
    const noneSelected = printColumnsConfig.every(
        (col) => !printColumnVisibility[col.key]
    );
    const handleSelectAll = () => {
        const updated = {};
        printColumnsConfig.forEach((col) => {
            updated[col.key] = true;
        });
        setPrintColumnVisibility(updated);
    };

    const handleDeselectAll = () => {
        const updated = {};
        printColumnsConfig.forEach((col) => {
            updated[col.key] = false;
        });
        setPrintColumnVisibility(updated);
    };

    const togglePrintColumn = (key) => {
        setPrintColumnVisibility((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };


    const getChargeClass = (item) => {
        const rcvdCharges = item.recvdCharge ?? "";
        const secCharges = item.SecrecvdCharge ?? "";

        if (rcvdCharges === "" && secCharges === "") {
            return item.Status === "5" ? "BilledClaims" : "UnPaidClaims";
        }

        const dblRecv = parseFloat(rcvdCharges) || 0;
        const dblSec = parseFloat(secCharges) || 0;

        return (dblRecv > 0 || dblSec > 0) ? "PaidClaims" : "NonPaidClaims";
    };


    return (
        <>
            <div
                className="main-container"
                style={{ width: "100%", marginTop: "0px" }}
            >
                <div className="container-style">
                    <div className="topnavmenu">
                        <label className="active-label">Claim Status</label>
                    </div>

                    <div className="searchfilter-container" style={{ height: "60px" }}>
                        <div className="searchfilter-style">
                            <div className="date-container mt-2">
                                <div>
                                    <select
                                        name="select"
                                        style={{ height: "25px", height: "30px" }}
                                        value={selectedDropdownValue}
                                        onChange={(e) => setSelectedDropdownValue(e.target.value)}
                                    >
                                        <option value="DOS">DOS</option>

                                        <option value="SubmitDate">To Approve</option>
                                        <option value="DOSub">Submit Date</option>
                                    </select>
                                </div>

                                <div
                                    className="datepicker-container"
                                    style={{ marginLeft: "5px", zIndex: 10 }}
                                >
                                    <label>From:</label>
                                    <DatePicker
                                        selected={startDate ? new Date(startDate) : null}
                                        onChange={handleStartDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        readOnly={isHideChecked}
                                        className={`clnImgTextBoxes ${startDate ? "default-selected" : ""}`}
                                        placeholderText="MM/dd/yyyy"
                                        calendarContainer={CalendarStartContainer}
                                        open={isStartOpen}
                                        onFocus={() => setIsStartOpen(true)}
                                        onInputClick={() => setIsStartOpen(true)}
                                        onClickOutside={() => setIsStartOpen(false)}
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                        }) => {
                                            const selectedDate =
                                                date instanceof Date && !isNaN(date)
                                                    ? date
                                                    : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button
                                                        onClick={decreaseMonth}
                                                        disabled={prevMonthButtonDisabled}
                                                        style={{ height: "25px" }}
                                                    >
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) =>
                                                            changeMonth(Number(value))
                                                        }
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) =>
                                                            changeYear(Number(value))
                                                        }
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option
                                                                key={k}
                                                                value={new Date().getFullYear() - k}
                                                            >
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button
                                                        onClick={increaseMonth}
                                                        disabled={nextMonthButtonDisabled}
                                                        style={{ height: "25px" }}
                                                    >
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div
                                    className="datepicker-container"
                                    style={{ marginLeft: "5px", zIndex: 10 }}
                                >
                                    <label>To:</label>
                                    <DatePicker
                                        selected={endDate ? new Date(endDate) : null}
                                        onChange={handleEndDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        className={`clnImgTextBoxes ${endDate ? "default-selected" : ""}`}
                                        placeholderText="MM/dd/yyyy"
                                        popperPlacement="bottom-start"
                                        readOnly={isHideChecked}
                                        calendarContainer={CalendarContainer}
                                        open={isEndOpen}
                                        onFocus={() => setIsEndOpen(true)}
                                        onInputClick={() => setIsEndOpen(true)}
                                        onClickOutside={() => setIsEndOpen(false)}
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                        }) => {
                                            const selectedDate =
                                                date instanceof Date && !isNaN(date)
                                                    ? date
                                                    : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button
                                                        onClick={decreaseMonth}
                                                        disabled={prevMonthButtonDisabled}
                                                        style={{ height: "25px" }}
                                                    >
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) =>
                                                            changeMonth(Number(value))
                                                        }
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) =>
                                                            changeYear(Number(value))
                                                        }
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option
                                                                key={k}
                                                                value={new Date().getFullYear() - k}
                                                            >
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button
                                                        onClick={increaseMonth}
                                                        disabled={nextMonthButtonDisabled}
                                                        style={{ height: "25px" }}
                                                    >
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div>
                                    <label style={{ marginLeft: "25px", marginTop: "3px" }}>
                                        All
                                    </label>
                                    <input
                                        style={{ marginLeft: "10px" }}
                                        type="checkbox"
                                        checked={isHideChecked}
                                        onChange={handleHideCheckboxChange}
                                    />
                                </div>
                            </div>

                            <div className="locfilter-style mt-2">
                                <label>Location:</label>
                                <select
                                    name="select"
                                    style={{
                                        width: "140px",
                                        marginLeft: "2px",
                                        height: "30px",
                                        borderRadius: "5px",
                                        backgroundColor:
                                            selectedLocation !== "-1"
                                                ? locations.find(
                                                    (loc) => loc.LocationId == selectedLocation,
                                                )?.Color || "#fff"
                                                : "#fff",
                                    }}
                                    value={selectedLocation}
                                    onChange={handleLocationChange}
                                >
                                    <option value="-1">All</option>

                                    {locations.map((item, index) => (
                                        <option
                                            key={index}
                                            value={item.LocationId}
                                            style={{ backgroundColor: item.Color }}
                                        >
                                            {item.LocationName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="suggestfilter-style mt-2">
                                <div style={{ width: "200px" }}>
                                    <label>Search By:</label>
                                    <select
                                        name="select"
                                        style={{ width: "110px", height: "30px", color: "black" }}
                                        value={selectedSearchFilter}
                                        onChange={handleFilterChange}
                                    >
                                        <option value="0"> </option>
                                        <option value="1">Patient Name</option>
                                        <option value="2">Claim ID</option>
                                        <option value="3">Insurance</option>
                                        <option value="4">Verified By</option>
                                        <option value="5">Rendering Provider</option>
                                        <option value="6">Verified By all</option>
                                        <option value="7">Billing NPI</option>
                                        <option value="8">Submitted By</option>
                                        <option value="9">Updated By</option>
                                        <option value="10">Clearing House</option>
                                    </select>
                                </div>

                                {selectedSearchFilter === "7" ? (
                                    <div className="practice-style">
                                        <select
                                            name="select"
                                            style={{
                                                width: "100px",
                                                height: "30px",
                                                borderRadius: "5px",
                                                marginTop: "1px",
                                            }}
                                            value={selectpracticeBillingNPIs}
                                            onChange={(e) => {
                                                setSelectPracticeBillingNPIs(e.target.value);
                                                setSearchText(e.target.value);
                                            }}
                                        >
                                            {practiceBillingNPIs.map((item, index) => (
                                                <option key={index} value={item.NPI}>
                                                    {item.namewithNPI}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <div style={{ marginLeft: "1px" }}>
                                        <input
                                            type="text"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyDown={handleInputKeyPress}
                                            style={{ width: "100px", height: "30px" }}
                                        />
                                        <div className="autocomplete-style">
                                            <ul
                                                className="sugglist-style"
                                                style={{ width: "160px", fontSize: "1rem" }}
                                            >
                                                {suggestions.map((suggestion) => (
                                                    <li
                                                        key={suggestion.val}
                                                        value={suggestion.val}
                                                        onClick={() => handleSuggestionSelect(suggestion)}
                                                    >
                                                        {suggestion.label}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="d-flex">
                                <div className="status-style mt-2">
                                    <select
                                        style={{ width: "140px", height: "30px", marginTop: "3px" }}
                                        value={selectedStatusRadioButton}
                                        onChange={handleRadioButtonsChange}
                                    >
                                        <option value="">All Claims</option>
                                        <option value="sub">Submitted</option>
                                        <option value="nonsub">Non-Submitted</option>
                                        <option value="5">Forwarded</option>
                                        <option value="1">Paid</option>
                                        <option value="2">Rejected</option>
                                        <option value="deni">Denied</option>
                                        <option value="sec">Sec Claims</option>
                                        <option value="priskip">Primary Skipped</option>
                                    </select>
                                </div>

                                <div className="cpt-style mt-2" ref={cptRef}>
                                    <label className="mt-1">CPT:</label>
                                    <input
                                        type="text"
                                        style={{ width: "120px", height: "30px", marginTop: "3px" }}
                                        value={selectedCptValue}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyCPTDown}
                                    />
                                    {cptValueList.length > 0 && (
                                        <div style={{ position: "sticky" }}>
                                            <ul
                                                className="cptlist-style"
                                                style={{
                                                    width: "200px",
                                                    color: "black",
                                                    fontSize: "0.9rem",
                                                }}
                                            >
                                                {cptValueList.map((suggestion) => (
                                                    <li
                                                        key={suggestion.FeeID}
                                                        onMouseDown={() => handleCPTList(suggestion)}
                                                    >
                                                        {suggestion.CPTCode} - {suggestion.CPTDesc}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>

                                {showFilters && (
                                    <>
                                        <div className="closeclaim-style mt-2">
                                            <input
                                                style={{ marginLeft: "10px" }}
                                                type="checkbox"
                                                value={isClaimClosed}
                                                onChange={(e) => {
                                                    setIsClaimClosed(e.target.checked);
                                                }}
                                            />
                                            <label style={{ marginLeft: "5px", marginTop: "3px" }}>
                                                Show Closed Claims
                                            </label>
                                        </div>

                                        <div className="service-style mt-2">
                                            {claimservices.map((item, index) => (
                                                <div key={index}>
                                                    <input
                                                        style={{ marginLeft: "5px" }}
                                                        type="checkbox"
                                                        value={checkedServices}
                                                        checked={
                                                            checkedServices.includes(item.ServiceID) ||
                                                            (item.ServiceID === "0" && isNoServiceChecked)
                                                        }
                                                        onChange={() => handleClaimServiceChange(item)}
                                                    />
                                                    <label
                                                        style={{ marginLeft: "1px", marginTop: "3px" }}
                                                        value={item.ServiceID || "0"}
                                                    >
                                                        {" "}
                                                        {item.ServiceName || "No Service"}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                                <div className="morefilter-style mt-2">
                                    <button className="morebtn-style" onClick={toggleFilters}>
                                        {" "}
                                        {showFilters ? "Close Filters" : "More Filters"}
                                    </button>
                                </div>

                                <div className="fileicon-box mt-2">
                                    <FontAwesomeIcon
                                        style={{ marginTop: "8px", cursor: "pointer" }}
                                        onClick={handleCountPrint}
                                        icon={faPrint}
                                    />
                                    <FontAwesomeIcon
                                        style={{
                                            marginLeft: "8px",
                                            color: "green",
                                            marginTop: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={exportToCountExcel}
                                        icon={faFileExcel}
                                    />
                                    <FontAwesomeIcon
                                        style={{
                                            marginLeft: "8px",
                                            color: "red",
                                            marginTop: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={exportToCountPDF}
                                        icon={faFilePdf}
                                    />
                                </div>

                                <div className="hideview-style mt-2">
                                    <div
                                        className="btn-group"
                                        role="group"
                                        aria-label="Basic radio toggle button group"
                                    >
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="btnradio"
                                            id="btnradio1"
                                            autocomplete="off"
                                            checked
                                            value={selectedViewType}
                                            onChange={(e) => setSelectedViewType(e.target.value)}
                                        />
                                        <label
                                            className="btn btn-outline-primary"
                                            htmlFor="btnradio1"
                                            value="0"
                                        >
                                            Detailed View
                                        </label>

                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="btnradio"
                                            id="btnradio2"
                                            autocomplete="off"
                                            value={selectedViewType}
                                            onChange={(e) => setSelectedViewType(e.target.value)}
                                        />
                                        <label
                                            className="btn btn-outline-primary"
                                            htmlFor="btnradio2"
                                            value="1"
                                        >
                                            Comprehensive View
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="searchicon-container"
                                style={{ marginLeft: "10px", marginTop: "8px" }}
                            >
                                <FontAwesomeIcon
                                    style={{
                                        marginLeft: "7px",
                                        marginTop: "5px",
                                        cursor: "pointer",
                                        fontSize: "1.5rem",
                                    }}
                                    onClick={(e) => handleTableDataClick(e, selectedServiceIDs)}
                                    icon={faMagnifyingGlass}
                                />
                            </div>
                        </div>
                    </div>

                    {loading && (
                        <div className="overlay">
                            <div className="spinner-container">
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="subtable-container">
                        <table
                            className="table table-hover table-striped table-bordered border border-white responsive mt-1 "
                            style={{ marginLeft: "4px", width: "100%" }}
                            ref={tableCountRef}
                        >
                            <thead>
                                <tr className="align-top">
                                    <th
                                        className="col-sm col-th  text-white"
                                        style={{ backgroundColor: "#0173b7" }}
                                    >
                                        #
                                    </th>

                                    <th
                                        className="col col-th-style  text-white"
                                        style={{ backgroundColor: "#0173b7", width: "280px" }}
                                    >
                                        DOS
                                        <br />
                                        <input
                                            style={{
                                                width: "100px",
                                                height: "30px",
                                                borderRadius: "5px",
                                            }}
                                            type="text"
                                            placeholder="Search"
                                            value={searchByClaimDos}
                                            onChange={(e) => setSearchByClaimDos(e.target.value)}
                                        />
                                    </th>
                                    <th
                                        className="col col-th text-white "
                                        style={{ backgroundColor: "#0173b7", width: "280px" }}
                                    >
                                        All CPT Lines
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isClaimChecked}
                                            onChange={handleClaimCheckboxChange}
                                        />
                                    </th>

                                    <th
                                        className="col col-th-style  text-white"
                                        style={{ backgroundColor: "#c9c9b2", width: "280px" }}
                                    >
                                        Submitted
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isSubmitChecked}
                                            onChange={(e) => {
                                                setIsSubmitChecked(!isSubmitChecked);
                                            }}
                                        />
                                    </th>

                                    <th
                                        className="col col-th-style  text-white"
                                        style={{ backgroundColor: "#c9c9b2", width: "280px" }}
                                    >
                                        Non-submitted
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isNonSubmitChecked}
                                            onChange={(e) => {
                                                setIsNonSubmitChecked(!isNonSubmitChecked);
                                            }}
                                        />
                                    </th>

                                    <th
                                        className="col col-th-style "
                                        style={{ backgroundColor: "#e9e993", color: "black" }}
                                    >
                                        SENT
                                        <FontAwesomeIcon
                                            className="hide-on-print"
                                            style={{ marginLeft: "5px", fontSize: "0.9rem" }}
                                            title="Submitted to clearing house"
                                            icon={faCircleInfo}
                                        />
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isSentChecked}
                                            onChange={(e) => {
                                                setIsSentChecked(!isSentChecked);
                                            }}
                                        />
                                    </th>
                                    <th
                                        className="col col-th-style"
                                        style={{ backgroundColor: "#e9e993", color: "black" }}
                                    >
                                        FORWARDED
                                        <FontAwesomeIcon
                                            className="hide-on-print"
                                            style={{ marginLeft: "5px", fontSize: "0.9rem" }}
                                            title="Forwarded to insurance"
                                            icon={faCircleInfo}
                                        />
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isForwardChecked}
                                            onChange={(e) => {
                                                setIsForwardChecked(!isForwardChecked);
                                            }}
                                        />
                                    </th>

                                    <th
                                        className="col col-th-style"
                                        style={{ backgroundColor: "#e9e993", color: "black" }}
                                    >
                                        RECEIVED
                                        <FontAwesomeIcon
                                            className="hide-on-print"
                                            style={{ marginLeft: "5px", fontSize: "0.9rem" }}
                                            title="Total payments received"
                                            icon={faCircleInfo}
                                        />
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isRecvdChecked}
                                            onChange={(e) => {
                                                setIsRecvdChecked(!isRecvdChecked);
                                            }}
                                        />
                                    </th>

                                    <th
                                        className="col col-th-style"
                                        style={{ backgroundColor: "#e9e993", color: "black" }}
                                    >
                                        POSTED
                                        <FontAwesomeIcon
                                            className="hide-on-print"
                                            style={{ marginLeft: "5px", fontSize: "0.9rem" }}
                                            title="Total payments posted (PAID+DENIED)"
                                            icon={faCircleInfo}
                                        />
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isPostedChecked}
                                            onChange={(e) => {
                                                setIsPostedChecked(!isPostedChecked);
                                            }}
                                        />
                                    </th>
                                    <th
                                        className="col col-th-style"
                                        style={{ backgroundColor: "#e9e993", color: "black" }}
                                    >
                                        PAID
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isPaidChecked}
                                            onChange={(e) => {
                                                setIsPaidChecked(!isPaidChecked);
                                            }}
                                        />
                                    </th>
                                    <th
                                        className="col col-th-style"
                                        style={{ backgroundColor: "#e9e993", color: "black" }}
                                    >
                                        REJECTED
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isRejectedChecked}
                                            onChange={(e) => {
                                                setIsRejectedChecked(!isRejectedChecked);
                                            }}
                                        />
                                    </th>

                                    <th
                                        className="col col-th-style  text-white"
                                        style={{ backgroundColor: "#0173b7", width: "280px" }}
                                    >
                                        DENIED
                                        <input
                                            type="checkbox"
                                            style={{ marginLeft: "5px", accentColor: "#86cb7a" }}
                                            checked={isDeniedChecked}
                                            onChange={(e) => {
                                                setIsDeniedChecked(!isDeniedChecked);
                                            }}
                                        />
                                        <FontAwesomeIcon
                                            className="hide-on-print"
                                            style={{ marginLeft: "50px" }}
                                            icon={showDetails ? faAnglesUp : faAnglesDown}
                                            onClick={toggleDetails}
                                        />
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {claimRecCountsTableData.map(
                                    (item, index) =>
                                        showDetails && (
                                            <tr key={index}>
                                                <th>{index + 1}</th>
                                                <td>
                                                    {item.DOS}
                                                    {item.DOSDay}
                                                </td>
                                                <td>{item.AllClaims}</td>
                                                <td style={{ backgroundColor: "#c9c9b2" }}>
                                                    {item.Submitted}
                                                </td>
                                                <td style={{ backgroundColor: "#c9c9b2" }}>
                                                    {item.NonSubmitted}
                                                </td>
                                                <td
                                                    style={{ backgroundColor: "#e9e993", color: "black" }}
                                                >
                                                    {item.SENT}
                                                </td>
                                                <td
                                                    style={{ backgroundColor: "#e9e993", color: "black" }}
                                                >
                                                    {item.FORWARDED}
                                                </td>
                                                <td
                                                    style={{ backgroundColor: "#e9e993", color: "black" }}
                                                >
                                                    {item.PaymentReceived}
                                                </td>
                                                <td
                                                    style={{ backgroundColor: "#e9e993", color: "black" }}
                                                >
                                                    {item.PaymentPosted}
                                                </td>
                                                <td
                                                    style={{ backgroundColor: "#e9e993", color: "black" }}
                                                >
                                                    {item.PAID}
                                                </td>
                                                <td
                                                    style={{ backgroundColor: "#e9e993", color: "black" }}
                                                >
                                                    {item.REJECTED}
                                                </td>
                                                <td>{item.DENIED}</td>
                                            </tr>
                                        ),
                                )}
                            </tbody>

                            <tr style={{ backgroundColor: "lightgray" }}>
                                <th></th>
                                <td className="table-bordered border border-white "> Total</td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "totalRecords" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("all");
                                        handleClaimCountsClick("totalRecords");
                                    }}
                                >
                                    {totalsClaims.allClaims}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "submit" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("submit", true, "");
                                        handleClaimCountsClick("submit");
                                    }}
                                >
                                    {totalsClaims.totalSubmitClaim}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "nonsubmit" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("nonsubmit", true, "");
                                        handleClaimCountsClick("nonsubmit");
                                    }}
                                >
                                    {totalsClaims.totalNonSubmitted}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "sent" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("sent", true, "");
                                        handleClaimCountsClick("sent");
                                    }}
                                >
                                    {totalsClaims.totalSent}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "fwd" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("fwd", true, "");
                                        handleClaimCountsClick("fwd");
                                    }}
                                >
                                    {totalsClaims.totalForwarded}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "recvd" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("recvd", true, "");
                                        handleClaimCountsClick("recvd");
                                    }}
                                >
                                    {totalsClaims.totalReceivedClaim}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "posted" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("posted", true, "");
                                        handleClaimCountsClick("posted");
                                    }}
                                >
                                    {totalsClaims.totalPosted}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "paid" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("paid", true, "");
                                        handleClaimCountsClick("paid");
                                    }}
                                >
                                    {totalsClaims.totalPaid}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "rejected" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("rejected", true, "");
                                        handleClaimCountsClick("rejected");
                                    }}
                                >
                                    {totalsClaims.totalRejected}
                                </td>
                                <td
                                    className={`table-bordered border border-white rectext ${activeCounts === "denied" ? "active-record" : ""}`}
                                    onClick={() => {
                                        ReloadClaimsData("denied", true, "");
                                        handleClaimCountsClick("denied");
                                    }}
                                >
                                    {totalsClaims.totalDenied}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div className="view-container">
                        <div
                            style={{
                                marginLeft: "820px",
                                marginTop: "8px",
                                width: "max-content",
                            }}
                            className="view-style"
                        >
                            View
                            <select
                                name="select"
                                id=""
                                style={{
                                    marginLeft: "4px",
                                    width: "120px",
                                    height: "25px",
                                    borderRadius: "5px",
                                    marginTop: "2px",
                                }}
                                value={selectedRecValue}
                                onChange={handleSelectChange}
                            >
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="75">75</option>
                                <option value="100">100</option>
                                <option value="all">All</option>
                            </select>
                            <label style={{ width: "max-content", marginLeft: "2px" }}>
                                records of {totalRecords} claim(s)
                            </label>
                        </div>

            <div className="icon-box" style={{ marginTop: "8px" }}>
              <FontAwesomeIcon
                style={{ marginTop: "8px", cursor: "pointer" }}
                onClick={() => setOpenPrintFilter(true)}
                icon={faPrint}
              />
   <FontAwesomeIcon
                                        style={{
                                            marginLeft: "8px",
                                            color: "green",
                                            marginTop: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={exportToExcel}
                                        icon={faFileExcel}
                                    />
              <FontAwesomeIcon
                style={{
                  marginLeft: "8px",
                  color: "red",
                  marginTop: "8px",
                  cursor: "pointer",
                }}
                onClick={exportToPDF}
                icon={faFilePdf}
              />
            </div>
          </div>
        <PrintColumnModal
  isOpen={isOpenPrintFilter}
  onClose={() => setOpenPrintFilter(false)}
  columns={printColumnsConfig}
  columnVisibility={printColumnVisibility}
  toggleColumn={togglePrintColumn}
  handleSelectAll={handleSelectAll}
  handleDeselectAll={handleDeselectAll}
  allSelected={allSelected}
  noneSelected={noneSelected}
  onPrint={handlePrint}
/>
          <div className="table-container" ref={tableRef}>
            <table className="fixed-header table table-hover border-secondary table-bordered table-info border responsive mt-1 " ref={tableContainerRef}>



                            <thead>

                                <tr className='align-top'>

                                    <th className=' border-white col-sm col-th  text-white sticky-col-1 ' style={{ backgroundColor: '#0173b7', width: '50px', }}>#</th>
                                    <th className=' border-white col col-th-style  text-white sticky-col-2 ' style={{ backgroundColor: '#0173b7', width: '100px' }} >
                                        <Link className='text-white' onClick={() => handleSort('LocationNickname')}>Location</Link>
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByLocation}
                                            onChange={(e) => setSearchByLocation(e.target.value)}
                                        />
                                    </th>
                                    <th className=' border-white col col-th-style  text-white sticky-col-3' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        <Link className='text-white' onClick={() => handleSort('ClaimDOS')}>DOS</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByDOS}
                                            onChange={(e) => setSearchByDOS(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col col-th-style  text-white sticky-col-4' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('ClaimId')}>Claim #</Link>
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByClaim}
                                            onChange={(e) => setSearchByClaim(e.target.value)}
                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white sticky-col-5' style={{ backgroundColor: '#0173b7', }}>
                                        <Link className='text-white' onClick={() => handleSort('FullName', (item) => `${item.LastName}, ${item.FirstName}`)}>Patient Name</Link>


                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            type='text'
                                            placeholder='Search'
                                            value={searchByPatient}
                                            onChange={(e) => setSearchByPatient(e.target.value)}
                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7', }}>
                                        <Link className='text-white' onClick={() => handleSort('ClaimConType')}>BH/SUD</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            type='text'
                                            placeholder='Search'
                                            value={searchBySUD}
                                            onChange={(e) => setSearchBySUD(e.target.value)}

                                        />

                                    </th>

                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        <Link className='text-white' onClick={() => handleSort('DOB')}>DOB</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            type='text'
                                            placeholder='Search'
                                            value={searchByDOB}
                                            onChange={(e) => setSearchByDOB(e.target.value)}
                                        />
                                    </th>


                                    <th className=' border-white col col-th-style  text-white PriInsData' >
                                        <a style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PolicyNumber')}>Insurance(Pri)</a>


                                        <br />

                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByInsurance}
                                            onChange={(e) => setSearchByInsurance(e.target.value)}
                                        />

                                        <br />

                                        <button className='btn-style3 mt-2 hide-on-print' onClick={(e) => handleCheckeligibility(e)}>Check</button>

                                        <input className='hide-on-print' style={{ float: 'right', marginTop: '15px' }} type='checkbox'

                                            onChange={() => handleSelectInsuranceAllChange('all')}
                                        />


                                    </th>

                                    <th className=' border-white col col-th-style  text-white SecInsData'>
                                        <a style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecInsPolicyNumber')}>Insurance(Sec)</a>

                                        <br />

                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchBySecInsurance}
                                            onChange={(e) => setSearchBySecInsurance(e.target.value)}
                                        />

                                        <br />

                                        <button className='btn-style3 mt-2 hide-on-print' onClick={(e) => handleSecCheckeligibility(e)} >Check</button>

                                        <input className='hide-on-print' style={{ float: 'right', marginTop: '15px' }} type='checkbox'
                                            onChange={() => handleSelectSecInsuranceAllChange('all')}
                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white thead' onClick={() => handleSort('ClearingHouseName')}>Clearing House</Link>
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByClearingHouse}
                                            onChange={(e) => setSearchByClearingHouse(e.target.value)}
                                        />
                                    </th>




                                    <th className=' border-white col col-th-style  text-white PriInsData'>
                                        <label ></label>
                                        <Link className='thead' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SubmitDate')}>Submit Date(Pri)</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySubmitdate}
                                            onChange={(e) => setSearchBySubmitdate(e.target.value)}
                                        />
                                    </th>


                                    <th className=' border-white col col-th-style  text-white SecInsData'>

                                        <Link className='thead' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecClaimSubmiDate')}>Submit Date(Sec)</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecSubmitdate}
                                            onChange={(e) => setSearchBySecSubmitdate(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7' }}>
                                        <label className='print-label '>Status</label>

                                        <br />
                                        <div className='hide-on-print'>
                                            <label className={`not-submit-style ${statusFilter === 0 ? 'active' : ''}`} title='Not-Submitted' onClick={() => handleStatusFilterChange(0)}>N</label>
                                            <label className={`denied-style ${statusFilter === 9 ? 'active' : ''}`} title='Denied' onClick={() => handleStatusFilterChange(9)}>D</label>
                                            <label className={`paid-style ${statusFilter === 1 ? 'active' : ''}`} title='Paid' onClick={() => handleStatusFilterChange(1)}>P</label>
                                            <label className={`forwarded-style ${statusFilter === 5 ? 'active' : ''}`} title='Forwarded' onClick={() => handleStatusFilterChange(5)}>F</label>
                                            <label className={`rejected-style ${statusFilter === 2 ? 'active' : ''}`} title='Rejected' onClick={() => handleStatusFilterChange(2)}>R</label>
                                            <label className={`NonPaidClaims ${statusFilter === 10 ? 'active' : ''}`} title='NonPaidClaims' onClick={() => handleStatusFilterChange(10)}>P0</label>
                                            <label className={`NonPaidClaims ${statusFilter === 11 ? 'active' : ''}`} title='NonPaidClaims' onClick={() => handleStatusFilterChange(11)}>S0</label>
                                        </div>
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByStatus}
                                            onChange={(e) => setSearchByStatus(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('CPTOld')}>CPT</Link>
                                        <br />
                                        <div className=' unpaid-claims'>R</div>

                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px', marginTop: '2px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByCPT}
                                            onChange={(e) => setSearchByCPT(e.target.value)}
                                        />


                                    </th>

                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>
                                        <Link className='text-white' onClick={() => handleSort('Units')}>Units</Link>
                                    </th>

                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('totalcharge')}>Total Charge</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByTotalCharge}
                                            onChange={(e) => setSearchByTotalCharge(e.target.value)}
                                        />
                                    </th>



                                    <th className=' border-white col-sm col-th text-white PriInsData'>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('recvdCharge')}>Charge Recieved(Pri)</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByRcvdCharge}
                                            onChange={(e) => setSearchByRcvdCharge(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white SecInsData'>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecrecvdCharge')}>Charge Recieved(Sec)</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecRcvdCharge}
                                            onChange={(e) => setSearchBySecRcvdCharge(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('Adjustment')}>Contractual Adjustment</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            defaultValue={searchByAdjustmentAmt}
                                            onChange={(e) => setSearchByAdjustmentAmt(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecPendingAmt')}>Secondary Pending</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            defaultValue={searchBySecPendingAmt}
                                            onChange={(e) => setSearchBySecPendingAmt(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('Deductible')}>Deductible</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByDeductible}
                                            onChange={(e) => setSearchByDeductible(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('PatientAmount')}>Pat Res</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByPatientRes}
                                            onChange={(e) => setSearchByPatientRes(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('Copay')}>COPAY</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByCopay}
                                            onChange={(e) => setSearchByCopay(e.target.value)}
                                        />
                                    </th>
                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('FederalPayment')}>Other Adjustment</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByOtherAdj}
                                            onChange={(e) => setSearchByOtherAdj(e.target.value)}
                                        />
                                    </th>
                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('FederalPayment')}>Federal Reduction</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchFederal}
                                            onChange={(e) => setSearchFederal(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('WriteOffAmount')}>Write-off</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByWriteOffValue}
                                            onChange={(e) => setSearchByWriteOffValue(e.target.value)}
                                        />
                                        <br />
                                        <input
                                            type="checkbox"
                                            checked={
                                                tableDetails
                                                    .filter(item => item.iClosed !== 1)
                                                    .every(openItem =>
                                                        selectedWriteOffRows.some(selected => selected.ClaimId === openItem.ClaimId)
                                                    )
                                            }
                                            onChange={handleWriteOffSelectAllChange}
                                        />


                                        <button className='btn-style3 hide-on-print' onClick={ClosclaimWithCPT}>Close</button>

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('AdminWriteOff')}>Admin Write-off</Link>

                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByAdminWriteOffValue}
                                            onChange={(e) => setSearchByAdminWriteOffValue(e.target.value)}
                                        />

                                        <br />
                                        <input type='checkbox'
                                            checked={selectAllAdminWriteChecked}
                                            onChange={() => handleAdminSelectAllChange('all')} />
                                        <button className='btn-style3 hide-on-print' onClick={handleOpenModal}>Write-off</button>

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('claimbln')}>Balance</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByBalance}
                                            onChange={(e) => setSearchByBalance(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white PriInsData' >

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PaymentChqueNo')}>Cheque #(Pri)</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByCheckNum}
                                            onChange={(e) => setSearchByCheckNum(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white PriInsData'>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PaymentChequeDate')}>Cheque Date(Pri)</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByCheckDate}
                                            onChange={(e) => setSearchByCheckDate(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white PriInsData'>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PayerRefNumber')}>Payer Ref #(Pri)</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByPayerRef}
                                            onChange={(e) => setSearchByPayerRef(e.target.value)}

                                        />
                                    </th>



                                    <th className=' border-white col-sm col-th text-white SecInsData'>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecCPTChequeNumber')}>Cheque #(Sec)</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            placeholder='Search'
                                            className='hide-on-print'
                                            value={searchBySecCheckNum}
                                            onChange={(e) => setSearchBySecCheckNum(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white SecInsData'>

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecCPTChequeDate')}>Cheque Date(Sec)</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecCheckDate}
                                            onChange={(e) => setSearchBySecCheckDate(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white SecInsData' >

                                        <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecPayerclaimRefNumber')}>
                                            Payer Ref #(Sec)
                                        </Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchBySecPayerRef}
                                            onChange={(e) => setSearchBySecPayerRef(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('providername')}>Provider</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByProvider}
                                            onChange={(e) => setSearchByProvider(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('UpdaterName')}>Updated By</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByUpdatedBy}
                                            onChange={(e) => setSearchByUpdatedBy(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('SubmitterName')}>Submitted By</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchBySubmittedBy}
                                            onChange={(e) => setSearchBySubmittedBy(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        Adjustment / Denial /Rejection Code

                                        <br />
                                        <input className='hide-on-print' style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'

                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Remarks
                                        <br />
                                        <input className='hide-on-print' style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'

                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Error Details
                                        <br />
                                        <input className='hide-on-print' style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'

                                        />

                                    </th>
                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Attachments

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('verifiedBy')}>Verified By</Link>
                                        <br />
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'

                                        />

                                    </th>



                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}><Link style={{ color: 'white' }}>Resubmit</Link>
                                        <input style={{ marginLeft: '3px' }} type='checkbox'
                                            checked={selectAllResubmit}
                                            onChange={() => handleResubmitAllChange('all')} />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('ClaimNotes')}>Notes</Link>

                                    </th>


                                </tr>

                            </thead>


                            <tbody >



                                {displayedRecords.length > 0 ? (
                                    displayedRecords.slice(0, visibleRecords).map((item, index) => {
                                        if (item.IsCPTMoved == 1) return null;

                                        const isClaimIdRepeated = claimIdCount[item.ClaimId] > 1;
                                        const backgroundColor = isClaimIdRepeated ? claimIdColors[item.ClaimId] : '';
                                        const cleanStatus = removeHtmlTags(item.ClaimStatusFlag || "");

                                        const isDeniedOrPartial =
                                            cleanStatus === "D" || cleanStatus === "P0" || item.recvdCharge == 0;

                                        const claimHx = item.ClaimHx;
                                        const [prefix, suffix] = claimHx ? claimHx.split('$') : [];
                                        const isCheckboxEnabled = parseFloat(item.recvdCharge) <= 0 || item?.ClaimStatus === 'Rejected';


                                        return (
                                            <tr
                                                className={`
                                                    ${item.iClosed === 1
                                                        ? 'table-secondary'
                                                        : item.DataValidationMessage && activeRow !== index
                                                            ? 'table-danger'
                                                            : activeRow === index
                                                                ? 'table-warning'
                                                                : ''
                                                    }
                                               `}
                                                // style={{ backgroundColor: isPrimaryRow ? 'yellow' : '' }}

                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={item.DataValidationMessage || ''}
                                                key={index}
                                                onClick={() => handleRowClick(index)}


                                            >


                                                <td className='table-bordered border border-white sticky-col-1' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                                                <td className='table-bordered border border-white sticky-col-2' style={{ width: '100px' }}><label style={{ backgroundColor: item.LocationColor, padding: "4px 8px", borderRadius: "4px", color: item.LocationColor ? "#fff" : "#000" }}>{item.LocationNickname}</label></td>
                                                <td className='table-bordered border border-white sticky-col-3' style={{ backgroundColor, width: '120px' }}><label className='linkspan' onClick={() => handleDosLinkClick(item)}>

                                                    {formatDOSDate(item.ClaimDOS)}</label></td>
                                                <td className='table-bordered border border-white sticky-col-4' style={{ backgroundColor, backgroundColor: item.updatedby && item.UpdatedDateTime ? 'lightpink' : '' }}>

                                                    <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                                                        {item.ClaimId}
                                                    </span>

                                                    {prefix !== "F0" && (
                                                        <Link style={{ marginLeft: '10px' }} onClick={() => handleGetClaimSubmitHx(item)} >{prefix}</Link>
                                                    )}

                                                    <FontAwesomeIcon className='hide-on-print' style={{ marginLeft: '20px', color: '#000', fontWeight: '100' }} onClick={() => fetchGetAllEvents(item)} icon={faFile} />

                                                    {
                                                        !rowState[item.ClaimId]?.isHidden && (
                                                            <FontAwesomeIcon
                                                                style={{ marginLeft: '5px' }}
                                                                onClick={() => handleRegeneratePDFCMS(item)}
                                                                icon={faArrowsRotate}
                                                                className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon hide-on-print' : 'hide-on-print'}
                                                            />
                                                        )
                                                    }

                                                    <FontAwesomeIcon className='hide-on-print' style={{ marginLeft: '10px', color: 'red' }} onClick={() => GetPDFCMS(item)} icon={faFilePdf} />
                                                </td>
                                                <td className='table-bordered border border-white sticky-col-5' style={{ backgroundColor }}>
                                                    <label className={`linkspan print-label ${item.EligibilityCheckCount > 0 ? 'EligibilityChecked' : 'EligibilityNotChecked'}`} onClick={() => handlePatLinkClick(item)}>
                                                        {item.LastName},{item.FirstName}

                                                    </label>

                                                    {item.PatSecInscount > 0 && (
                                                        <span>
                                                            <FontAwesomeIcon className='show-icon' style={{ marginLeft: '10px' }} icon={faShieldHalved} />
                                                        </span>
                                                    )}

                                                </td>

                                                <td className='table-bordered border border-white'>

                                                    <label className={item.ClaimConType ? 'btnsud' : ''}>{item.ClaimConType}</label>

                                                </td>
                                                <td className='table-bordered border border-white' style={{ width: '120px' }}><label className='label-style' >{formatSubmitDate(item.DOB)}</label></td>
                                                <td className={`table-bordered border border-white ${item.IsPrimarySkipped === true ? 'InsSkipped' : ''}`} style={{ backgroundColor: '#f1f1c4' }}><label className='label-style'>{item.InsCompNickName}</label>
                                                    <br />
                                                    <label>{item.PayerID}</label>

                                                    <span className={`payer${index} print-label`}>
                                                        {item.PolicyNumber}
                                                    </span>

                                                    {item.IsPrimarySkipped === true && (
                                                        <div className="divSkipped skip-btn">
                                                            Skipped
                                                        </div>
                                                    )}




                                                    {rowState[item.ClaimId]?.isHidden && (
                                                        <FontAwesomeIcon
                                                            style={{ marginLeft: '5px' }}
                                                            icon={faSpinner}
                                                            className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon hide-on-print' : 'hide-on-print'}
                                                        />
                                                    )}



                                                    <input type='checkbox' style={{ marginLeft: '5px' }} className='hide-on-print'
                                                        key={index}
                                                        checked={insuranceAllCheckbox.includes(index)}
                                                        onChange={() => handleInsuranceRowCheckbox(index, item)}

                                                    />

                                                </td>
                                                <td className='table-bordered border border-white SecInsData'>
                                                    <label className='label-style'>{item.SecInsCompNickName}</label>
                                                    <br />

                                                    <label>{item.SecPayerID}</label>

                                                    <span className={`payer-id-${index}`}>
                                                        {item.SecInsPolicyNumber}
                                                    </span>

                                                    <input type='checkbox' style={{ marginLeft: '5px' }} className='hide-on-print'
                                                        checked={SecInsuranceAllCheckbox.includes(index)}
                                                        onChange={() => handleSecInsuranceCheckboxChange(index)}
                                                    />

                                                </td>

                                                <td className='table-bordered border border-white'><label>{item.ClearingHouseName}</label>
                                                </td>

                                                <td style={{ backgroundColor: '#f1f1c4' }} className={`table-bordered border border-white ${item.IsPrimarySkipped === true ? 'InsSkipped' : ''}`}>
                                                    <label className='label-style'>{formatSubmitDate(item.SubmitDate)}</label>
                                                    {item.IsPrimarySkipped === true && (
                                                        <div className="divSkipped mt-1 skip-btn">
                                                            Skipped
                                                        </div>
                                                    )}
                                                </td>
                                                <td className='table-bordered border border-white SecInsData'><label className='label-style'>{formatSubmitDate(item.SecClaimSubmiDate)}</label></td>
                                                <td className='table-bordered border border-white'>



                                                    <label title={getTooltip(item.PrimaryPaymentStatus)} dangerouslySetInnerHTML={{ __html: item.PrimaryPaymentStatus }}></label>
                                                    <label title={getTooltip(item.SecPaymentStatus)} dangerouslySetInnerHTML={{ __html: item.SecPaymentStatus }}></label>
                                                </td>

                                                <td className='table-bordered border border-white'><label className={getChargeClass(item)}>{item.CPTOld}</label>

                                                </td>
                                                <td className='table-bordered border border-white' style={{ width: '100px' }}><label>{item.Units}</label>

                                                </td>
                                                <td className='table-bordered border border-white'><label>{item.totalcharge}</label></td>

                                                <td
                                                    className={`table-bordered border border-white ${item.IsPrimarySkipped ? "InsSkipped" : ""
                                                        }`} style={{ backgroundColor: '#f1f1c4' }}
                                                >
                                                    $
                                                    <DebouncedInput
                                                        name="RecvdCharge"
                                                        value={item.recvdCharge ?? ""}
                                                        highlightCondition={item.recvdCharge !== null && item.recvdCharge !== ""}
                                                        isDeniedOrPartial={item.recvdCharge !== "" && Number(item.recvdCharge) === 0}
                                                        onSave={(val) => saveRecvdCharges(val, item)}
                                                    />

                                                    {item.IsPrimarySkipped && (
                                                        <div className="divSkipped mt-2 skip-btn">Skipped</div>
                                                    )}
                                                </td>

                                                <td className='table-bordered border border-white SecInsData'>
                                                    <DebouncedInput
                                                        name="SecrecvdCharge"
                                                        value={item.SecrecvdCharge ?? ""}
                                                        highlightCondition={item.SecrecvdCharge !== null && item.SecrecvdCharge !== ""}
                                                        isDeniedOrPartial={item.SecrecvdCharge !== "" && Number(item.SecrecvdCharge) === 0}
                                                        onSave={(val) => saveSecClaimRecvdCharges(val, item)}
                                                    />
                                                </td>


                                                <td style={{ backgroundColor: '#f1f1c4' }} className="table-bordered border border-white">
                                                    $
                                                    <DebouncedInput
                                                        name="Adjustment"
                                                        value={item.Adjustment}
                                                        highlightCondition={item.Adjustment !== 0}
                                                        onSave={(val) => saveAdjustmentCharges(val, item)}
                                                    />
                                                </td>



                                                <td className='table-bordered border border-white SecInsData'>
                                                    $<input type='text' className='input' style={{ width: '60px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecPendingAmt !== 0 ? 'lightgreen' : 'white' }}
                                                        value={
                                                            editedValues[item.ClaimId]?.SecPendingAmt !== undefined
                                                                ? editedValues[item.ClaimId]?.SecPendingAmt
                                                                : (item.SecPendingAmt ?? '')
                                                        }
                                                        onChange={(e) => handleInputChange(item.ClaimId, 'SecPendingAmt', e.target.value)}
                                                        onBlur={(e) => SaveSecPendingCharges(e.target.value, item, e)}

                                                    />
                                                </td>


                                                <td className='table-bordered border border-white'>
                                                    <DebouncedInput
                                                        name="Deductible"
                                                        value={item.Deductible ?? ""}
                                                        highlightCondition={!!item.Deductible}
                                                        onSave={(val) => saveClaimDeductible(val, item)}
                                                    />
                                                </td>

                                                <td className='table-bordered border border-white'>
                                                    <DebouncedInput
                                                        name="PatientAmount"
                                                        value={item.PatientAmount ?? ""}
                                                        highlightCondition={!!item.PatientAmount}
                                                        onSave={(val) => savePatRes(val, item)}
                                                    />
                                                </td>


                                                <td className='table-bordered border border-white'>
                                                    <input type='text' className='input' style={{
                                                        width: '60px', borderRadius: '5px', borderColor: 'lightgray',
                                                        backgroundColor: item.Copay !== null ? 'lightgray' : 'white'
                                                    }}
                                                        value={
                                                            editedValues[item.ClaimId]?.Copay !== undefined
                                                                ? editedValues[item.ClaimId]?.Copay
                                                                : (item.Copay ?? '')
                                                        }
                                                        onChange={(e) => handleInputChange(item.ClaimId, 'Copay', e.target.value)}
                                                        onBlur={(e) => SavePatientCopay(e.target.value, item, e)}
                                                    />


                                                    {(item.CopayAppliedClaim == 0 || item.CopayAppliedClaim === "") ? (
                                                        <button className='btn-style3' title='Copay collected from patient"' onClick={() => handleApplyCopayData(item)} >
                                                            {item.CopayAmount}
                                                        </button>
                                                    ) : item.CopayAppliedClaim == item.ClaimId ? (
                                                        <button className='btngrey' title={
                                                            'Copay applied to claim ' + item.CopayAppliedClaim +
                                                            ' by ' + item.CopayApliedByShortName +
                                                            ' on ' + item.CopayApliedOn
                                                        }>
                                                            {item.CopayAmount}
                                                        </button>
                                                    ) : null}

                                                </td>

                                                <td className='table-bordered border border-white'>
                                                    <DebouncedInput
                                                        name="OtherAdjustment"
                                                        value={item.OtherAdjustment ?? ""}
                                                        highlightCondition={!!item.OtherAdjustment}
                                                        onSave={(val) => SaveOtherAdjustment(val, item)}
                                                    />

                                                </td>

                                                <td className='table-bordered border border-white'>
                                                    <DebouncedInput
                                                        name="FederalReduction"
                                                        value={item.FederalReduction ?? ""}
                                                        highlightCondition={!!item.FederalReduction}
                                                        onSave={(val) => SaveFederalReduction(val, item)}
                                                    />

                                                </td>

                                                <td className='table-bordered border border-white'>
                                                    <DebouncedInput
                                                        name="WriteOffAmount"
                                                        value={item.WriteOffAmount ?? ""}
                                                        highlightCondition={!!item.WriteOffAmount}
                                                        onSave={(val) => saveClaimWriteOff(val, item)}
                                                    />

                                                    <input
                                                        type="checkbox"
                                                        checked={selectedWriteOffRows.some(selected => selected.ClaimId === item.ClaimId)}
                                                        disabled={item.iClosed === 1}
                                                        onChange={() => {
                                                            setSelectedWriteOffRows(prev => {
                                                                const isSelected = prev.some(selected => selected.ClaimId === item.ClaimId);
                                                                if (isSelected) {
                                                                    // remove the row object
                                                                    return prev.filter(selected => selected.ClaimId !== item.ClaimId);
                                                                } else {
                                                                    // add the full row object
                                                                    return [...prev, item];
                                                                }
                                                            });
                                                        }}
                                                    />

                                                </td>
                                                <td className='table-bordered border border-white'>
                                                    <DebouncedInput
                                                        name="AdminWriteOff"
                                                        value={adminWriteOffValues[index] ?? ""}
                                                        highlightCondition={!!adminWriteOffValues[index]}
                                                        onSave={(val) => handleAdminWriteOffChange(val, index)}
                                                    />

                                                    <input type='checkbox' style={{ marginLeft: '5px' }}
                                                        className='input'
                                                        checked={selectedAdminWriteRows.includes(index)}
                                                        onChange={() => handleAdminRowCheckboxChange(index)}
                                                    />
                                                </td>
                                                <td className='table-bordered border border-white'><label>{item.claimbln}</label>

                                                </td>


                                                <td style={{ backgroundColor: '#f1f1c4' }} className={`table-bordered border border-white ${item.IsPrimarySkipped === true ? 'InsSkipped' : ''}`}>
                                                    <input id={`PaymentChqueNo_${index}`} type='text' style={{ width: '150px', borderRadius: '5px', backgroundColor: item.PaymentChqueNo !== null ? 'lightgray' : 'white' }}
                                                        defaultValue={item.PaymentChqueNo}
                                                        className='input'
                                                        onBlur={(e) => SaveClaimCPTChequeNumber(e.target.value, item, e)}
                                                    />
                                                    {item.IsPrimarySkipped === true && (
                                                        <div className="divSkipped mt-2 skip-btn">
                                                            Skipped
                                                        </div>
                                                    )}

                                                </td>

                                                <td style={{ backgroundColor: '#f1f1c4' }} className={`table-bordered border border-white ${item.IsPrimarySkipped === true ? 'InsSkipped' : ''}`}>
                                                    <input type='date' style={{ width: '120px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.PaymentChequeDate !== null ? 'lightgray' : 'white' }}
                                                        className='input-date'
                                                        placeholder=""
                                                        value={formatDateForInput(item.PaymentChequeDate)}
                                                        onChange={(e) => UpdateClaimChequeDate(e.target.value, item)}
                                                    />

                                                    {item.IsPrimarySkipped === true && (
                                                        <div className="divSkipped mt-2 skip-btn">
                                                            Skipped
                                                        </div>
                                                    )}

                                                </td>
                                                <td style={{ backgroundColor: '#f1f1c4' }} className={`table-bordered border border-white ${item.IsPrimarySkipped === true ? 'InsSkipped' : ''}`}>
                                                    <input id='PayerRefNumber' type='text' style={{ width: '150px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.PayerRefNumber !== "" ? 'lightgray' : 'white' }}
                                                        className='input'
                                                        defaultValue={item.PayerRefNumber}
                                                        onBlur={(e) => SaveClaimsPayerRefID(e.target.value, item, e)}
                                                    />

                                                    {item.IsPrimarySkipped === true && (
                                                        <div className="divSkipped mt-2 skip-btn">
                                                            Skipped
                                                        </div>
                                                    )}
                                                </td>
                                                <td className='table-bordered border border-white SecInsData'>

                                                    <input id={`SecCPTChequeNumber${index}`} type='text' style={{ width: '150px', borderRadius: '5px', backgroundColor: item.SecCPTChequeNumber !== null ? 'lightgray' : 'white' }}
                                                        className='input'
                                                        defaultValue={item.SecCPTChequeNumber}
                                                        onBlur={(e) => SecSaveClaimCPTChequeNumber(e.target.value, item, e)}
                                                    />
                                                </td>

                                                <td className='table-bordered border border-white SecInsData'>
                                                    <input type='date' style={{ width: '120px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecCPTChequeDate !== null ? 'lightgray' : 'white' }}
                                                        placeholder=""
                                                        value={formatDateForInput(item.SecCPTChequeDate)}
                                                        onChange={(e) => SecUpdateClaimChequeDate(e.target.value, item)}
                                                    />

                                                </td>
                                                <td className='table-bordered border border-white SecInsData'>
                                                    <input id='SecPayerclaimRefNumber' type='text' style={{ width: '150px', borderRadius: '5px', borderColor: 'lightgray', backgroundColor: item.SecPayerclaimRefNumber !== null ? 'lightgray' : 'white' }}
                                                        className='input'
                                                        value={item.SecPayerclaimRefNumber}
                                                        onChange={(e) => SecSaveClaimsPayerRefID(e.target.value, item)}
                                                    />
                                                </td>
                                                <td className='table-bordered border border-white'>{item.providername}
                                                    <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                </td>
                                                <td className='table-bordered border border-white'>{item.UpdaterName}</td>
                                                <td className='table-bordered border border-white'>{item.SubmitterName}</td>
                                                <td className='table-bordered border border-white'>
                                                    <div
                                                        style={{
                                                            display: "inline-block",
                                                            marginRight: "5px",
                                                            padding: "4px 8px",
                                                            backgroundColor: "#eef2f7",
                                                            borderRadius: "4px",
                                                            cursor: "pointer"
                                                        }}>
                                                        {getClaimAdjustment(item.ClaimId)}
                                                    </div>

                                                </td>
                                                <td className='table-bordered border border-white'>{item.Remarks}
                                                    <div className='claimremarks'></div>
                                                    <div className='claimremarks'></div>
                                                </td>

                                                <td className='table-bordered border border-white'>
                                                    {item.ErrorDetails}
                                                </td>

                                                <td className='table-bordered border border-white'>
                                                    <Link onClick={() => handleGetClaimAttachments(item)}>{item.Attachments}</Link>
                                                </td>

                                                <td className='table-bordered border border-white' title={
                                                    item.verifiedBy || item.verifiedOn || item.VerificationComment
                                                        ? `Verified by ${item.verifiedBy ?? ""} on ${formatDOSDate(item.verifiedOn) ?? ""}${item.VerificationComment
                                                            ? `\n Comment : ${item.VerificationComment}`
                                                            : ""
                                                        }`
                                                        : ""
                                                }>
                                                    <div className='d-flex'>
                                                        <label>{getVerifiedBy(item.verifiedBy)}</label>
                                                        <button className={item.isVerified == 1 ? 'saving' : 'btn-style3 mt-2'}
                                                            onClick={() => handleOpenVerifiedModal(item)} disabled={dataSaved} >Verified</button>
                                                    </div>
                                                </td>



                                                <td className='table-bordered border border-white'>

                                                    <input style={{ marginLeft: '6px' }} type='checkbox'
                                                        key={index}
                                                        checked={selectedResubmitRows.includes(index)}
                                                        disabled={!isCheckboxEnabled}
                                                        onChange={() => handleReSubmitCheckboxChange(index)}
                                                    />
                                                </td>
                                                <td className='table-bordered border border-white'>
                                                    <textarea type='text' style={{ backgroundColor: item.ClaimNotes !== null ? 'lightgray' : 'white' }}
                                                        value={item.ClaimNotes}
                                                        onChange={(e) => UpdateClaimNotes(e.target.value, item)}
                                                    />

                                                </td>


                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>No records found</td>
                                    </tr>
                                )}






                            </tbody>




                            <tr style={{ backgroundColor: 'lightgray' }}>

                                <td className='table-bordered border border-white'></td>
                                <td className='table-bordered border border-white'>Total </td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white rectext'></td>
                                <td className='table-bordered border border-white'></td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'>{totals.totalUnits}</td>
                                <td className='table-bordered border border-white'>${totals.totalSubmitted.toFixed(2)}</td>
                                <td className='table-bordered border border-white'>${totals.totalReceived.toFixed(2)}</td>
                                <td className='table-bordered border border-white'>${totals.totalSecReceived.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalAdjustmentAmt.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalSecPendingAmt.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalDeductible.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalPatientRes.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalCopay.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalOtherAdjustment.toFixed(2)}</td>
                                <td className='table-bordered border border-white'>${totals.totalFederalReduction.toFixed(2)}</td>
                                <td className='table-bordered border border-white'>${totals.totalWriteOff.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalAdminWriteOff.toFixed(2)} </td>
                                <td className='table-bordered border border-white'>${totals.totalBalance.toFixed(2)} </td>

                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                                <td className='table-bordered border border-white'> </td>
                            </tr>




                        </table>



                        {showConfirmSaveModal && (

                            <div className='adminwrite-fax mt-5' ref={modalRef}>
                                <label>Select Transaction Code</label>
                                <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.3rem' }} onClick={handleCloseModals} icon={faXmark} />
                                <br />
                                <select style={{ width: '400px', height: '25px', marginTop: '3px' }}
                                    value={selectedTransactionCode}
                                    onChange={(e) => setSelectedTransactionCode(e.target.value)}
                                >
                                    {transactionCodes.map((item, index) => (

                                        <option value={item.TransactionCodeID}>{item.TransactionCodeDescription}</option>
                                    ))}
                                </select>

                                <br />
                                <button className='btn-style3 mt-2' onClick={saveAdminClaimWriteOff}>Submit</button>

                            </div>
                        )}



                        {showCopaySuccessModal && (
                            <div className="alertmsg-modal">
                                <label style={{ backgroundColor: "#18A6EC" }}></label>
                                <FontAwesomeIcon
                                    style={{
                                        float: "right",
                                        fontWeight: "bolder",
                                        fontSize: "1rem",
                                        backgroundColor: "red",
                                        padding: "5px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleCloseModals}
                                    icon={faXmark}
                                />
                                <div style={{ backgroundColor: "#18A6EC", color: "white", padding: "10px" }}>
                                    {errorMessage}
                                </div>
                            </div>
                        )}



                        {showVerifiedSaveModal && (

                            <div className='verified-fax' style={{ zIndex: 10 }}>

                                <textarea placeholder='comments' style={{ width: '300px', height: '80px', borderRadius: '5px' }}
                                    value={selectedVerifiedData}
                                    onChange={(e) => setSelectedVerifiedData(e.target.value)}
                                />
                                <br />
                                <button className='btn-style3 mt-2' onClick={handleCloseModals} >Cancel</button>
                                <button className='btn-style3 mt-2' onClick={handleSaveVerifiedData}>Confirm</button>

                            </div>
                        )}

                    </div>

                    {showServiceErrorModal && (
                        <div className="alert-modal">
                            <label></label>
                            <FontAwesomeIcon
                                style={{
                                    float: "right",
                                    fontWeight: "bolder",
                                    fontSize: "1.1rem",
                                    backgroundColor: "red",
                                }}
                                onClick={handleCloseModals}
                                icon={faXmark}
                            />
                            <p>please select atleast one Filter from Service...</p>
                        </div>
                    )}

                    {showSelectErrorModal && (
                        <div className="alert-modal">
                            <label></label>
                            <FontAwesomeIcon
                                style={{
                                    float: "right",
                                    fontWeight: "bolder",
                                    fontSize: "1.1rem",
                                    backgroundColor: "red",
                                }}
                                onClick={handleCloseModals}
                                icon={faXmark}
                            />
                            <p>please select atleast one claim...</p>
                        </div>
                    )}

                    {showSuccessModal && (
                        <div className="alert-modal">
                            <label></label>
                            <FontAwesomeIcon
                                style={{
                                    float: "right",
                                    fontWeight: "bolder",
                                    fontSize: "1.1rem",
                                    backgroundColor: "red",
                                }}
                                onClick={handleCloseModals}
                                icon={faXmark}
                            />
                            <p>Selected Claim Successfully Closed</p>
                        </div>
                    )}

                    {showPopup && (
                        <div
                            style={{
                                position: "fixed",
                                bottom: "50px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#333",
                                color: "#fff",
                                padding: "10px 20px",
                                borderRadius: "5px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                zIndex: 1000,
                                height: "100px",
                                width: "400px",
                                textAlign: "center",
                            }}
                        >
                            <label style={{ marginTop: "20px", fontSize: "1.4rem" }}>
                                {popupMessage}
                            </label>
                        </div>
                    )}

                    {showFaxModal && (
                        <Draggable>
                            <div className="dialog-box2">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <td className="topnavsub">
                                                <FontAwesomeIcon
                                                    style={{
                                                        width: "18px",
                                                        height: "18px",
                                                        borderRadius: "999px",
                                                        border: "1px solid black",
                                                        float: "right",
                                                        fontWeight: "bolder",
                                                        fontSize: "0.9rem",
                                                        backgroundColor: "red",
                                                        color: "white",
                                                    }}
                                                    onClick={handleCloseModals}
                                                    icon={faXmark}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{ backgroundColor: "#ECF7FB" }}>
                                                {" "}
                                                <label>Claim ID: {selectedClaimID} </label>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                {eventData.map((item, index) => (
                                                    <>
                                                        <div className="event-style" key={index}>
                                                            <label>{item.DataCurStatus}</label>
                                                            <br />
                                                            <label>
                                                                {formatDOSDate(item.EventDateTime)}-{" "}
                                                                {item.UserFName}
                                                            </label>
                                                        </div>

                                                        {index < eventData.length - 1 && (
                                                            <FontAwesomeIcon
                                                                style={{
                                                                    fontWeight: "bolder",
                                                                    fontSize: "1.8rem",
                                                                }}
                                                                icon={faArrowRight}
                                                            />
                                                        )}
                                                    </>
                                                ))}
                                            </td>
                                        </tr>
                                    </thead>

                                    <tbody></tbody>
                                </table>
                            </div>
                        </Draggable>
                    )}

                    {showattachmentData && (
                        <Draggable>
                            <div className="modal-box">
                                <FontAwesomeIcon
                                    style={{
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "999px",
                                        border: "1px solid black",
                                        float: "right",
                                        fontWeight: "bolder",
                                        fontSize: "0.9rem",
                                        backgroundColor: "red",
                                        color: "white",
                                    }}
                                    onClick={handleCloseModals}
                                    icon={faXmark}
                                />

                                <label>Claim ID: {attachmentClaimID} </label>

                                <div className=" mt-2">
                                    <table
                                        className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 "
                                        style={{ marginLeft: "5px", width: "100%" }}
                                    >
                                        <thead>
                                            <tr className="align-top" style={{ fontSize: "0.5rem" }}>
                                                <th
                                                    className="col-sm col-th  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    S NO
                                                </th>

                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Document Name
                                                </th>
                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Preview
                                                </th>
                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Uploaded Date
                                                </th>

                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Type
                                                </th>

                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Method
                                                </th>

                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    ACN
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {attachmentData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.DocumentName}</td>
                                                    <td>
                                                        <FontAwesomeIcon
                                                            className="hide-on-print"
                                                            style={{
                                                                marginLeft: "5px",
                                                                color: "red",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => GetDOCPDF(item.FileUrl)}
                                                            icon={faFilePdf}
                                                        />
                                                    </td>
                                                    <td>{formatDOSDate(item.UploadedDate)}</td>
                                                    <td>{item.PWK01}</td>
                                                    <td>{item.PWK02}</td>
                                                    <td>{item.PWK06}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Draggable>
                    )}

                    {showDataModal && (
                        <Draggable>
                            <div className="dialog-box3 p-2">
                                <div className="d-flex">
                                    <label
                                        style={{ fontFamily: "sans-serif", fontWeight: "600" }}
                                    >
                                        Patient Name:
                                        <Link>{selectedPatname}</Link>
                                    </label>

                                    <label
                                        style={{
                                            fontFamily: "sans-serif",
                                            fontWeight: "600",
                                            marginLeft: "60px",
                                        }}
                                    >
                                        DOB:{" "}
                                    </label>

                                    <label
                                        style={{
                                            fontFamily: "sans-serif",
                                            fontWeight: "500",
                                            marginLeft: "5px",
                                        }}
                                    >
                                        {selectedDOB}
                                    </label>

                                    <div className="topnavsub2">
                                        <FontAwesomeIcon
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                borderRadius: "999px",
                                                border: "1px solid black",
                                                float: "right",
                                                fontWeight: "bolder",
                                                fontSize: "0.9rem",
                                                backgroundColor: "red",
                                                color: "white",
                                                marginLeft: "40px",
                                            }}
                                            onClick={handleCloseModals}
                                            icon={faXmark}
                                        />
                                    </div>
                                </div>
                                <table className="table table-bordered border-secondary border-white">
                                    <thead>
                                        <tr></tr>

                                        <tr>
                                            <th
                                                className="text-white  border-white"
                                                style={{ backgroundColor: "#0173b7", width: "30px" }}
                                            >
                                                #
                                            </th>

                                            <th
                                                className="col col-th-style  text-white  border-white"
                                                style={{ backgroundColor: "#0173b7" }}
                                            >
                                                Claim ID
                                            </th>

                                            <th
                                                className="col col-th-style  text-white  border-white"
                                                style={{ backgroundColor: "#0173b7" }}
                                            >
                                                DOS
                                            </th>

                                            <th
                                                className="col col-th-style  text-white  border-white"
                                                style={{ backgroundColor: "#0173b7" }}
                                            >
                                                Submit Date
                                            </th>

                                            <th
                                                className="col col-th text-white  border-white"
                                                style={{ backgroundColor: "#0173b7" }}
                                            >
                                                <label style={{ width: "100px" }}>Submit By</label>
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </Draggable>
                    )}
                </div>
            </div>
        </>
    );
};

export default ClaimStatus;
